import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** `Date` type as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
};

/** account */
export type Account = {
  __typename?: 'Account';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Account type */
  accountType: AccountType;
  /** Age range */
  ageRange: AgeRange;
  /** Alternative languages */
  alternativeLanguages: Array<Scalars['String']['output']>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Device Ids */
  deviceIds: Array<Scalars['String']['output']>;
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Email */
  email: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Gender */
  gender: Gender;
  /** Is Test Account */
  isTestAccount: Scalars['Boolean']['output'];
  /** Last active at */
  lastActiveAt: Scalars['Timestamp']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Login name */
  loginName: Scalars['String']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** Password type */
  passwordType: PasswordType;
  /** Preferred language */
  preferredLanguage: Scalars['String']['output'];
  /** Score */
  score: Scores;
  /** SelfReport ids */
  selfReportIds: Array<Scalars['ID']['output']>;
  /** SelfReports */
  selfReports: Array<SelfReport>;
  /** Url */
  url: Scalars['String']['output'];
};

/** account and new highscore */
export type AccountNewHighscore = {
  __typename?: 'AccountNewHighscore';
  /** Artefact */
  account: Account;
  /** NewHighScore */
  newHighScore: NewHighScore;
};

export type AccountQuery = {
  /** Account types */
  accountTypes?: InputMaybe<Array<AccountType>>;
  /** Disabled */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AccountType {
  Administrator = 'Administrator',
  Participant = 'Participant',
  ProjectMember = 'ProjectMember'
}

export enum ActionApp {
  Booster = 'Booster',
  Chaser = 'Chaser',
  DigitalToolboxManager = 'DigitalToolboxManager',
  Server = 'Server'
}

export enum ActionVerb {
  Add = 'Add',
  Change = 'Change',
  Clear = 'Clear',
  Create = 'Create',
  Delete = 'Delete',
  Disable = 'Disable',
  Duplicate = 'Duplicate',
  Enable = 'Enable',
  Error = 'Error',
  Login = 'Login',
  Logout = 'Logout',
  MoveToTrash = 'MoveToTrash',
  Navigate = 'Navigate',
  QrCode = 'QrCode',
  Read = 'Read',
  Register = 'Register',
  Remove = 'Remove',
  Reorder = 'Reorder',
  RetrieveFromTrash = 'RetrieveFromTrash',
  Update = 'Update'
}

export type ActivityStreamObject = {
  __typename?: 'ActivityStreamObject';
  /** Actor */
  actor: Actor;
  /** App sequence number */
  appSequenceNumber: Scalars['Int']['output'];
  /** Generator */
  generator: Generator;
  /** Object */
  object: NextlabVerbs;
  /** Provider */
  provider: Provider;
  /** Published client date */
  published?: Maybe<Scalars['Timestamp']['output']>;
  /** Published server date */
  publishedServer?: Maybe<Scalars['Timestamp']['output']>;
  /** Session sequence number */
  sessionSequenceNumber: Scalars['Int']['output'];
  /** Target */
  target: Target;
  /** Verb */
  verb: NextlabVerbs;
};

export type Actor = {
  __typename?: 'Actor';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Id */
  id: Scalars['String']['output'];
  /** Object type */
  objectType: Scalars['String']['output'];
};

export type ActorInput = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Id */
  id: Scalars['String']['input'];
  /** Object type */
  objectType: Scalars['String']['input'];
};

export type AddLogActionInput = {
  /** Actor id */
  actorId: Scalars['ID']['input'];
  /** Action location */
  app: ActionApp;
  /** Created at */
  clientDate: Scalars['Timestamp']['input'];
  /** Description of action */
  description: Scalars['JSON']['input'];
  /** Session sequence number */
  sessionSequenceNumber: Scalars['Int']['input'];
  /** Target id */
  targetId: Scalars['ID']['input'];
  /** Target type */
  targetType: TargetTypes;
  /** Action verb */
  verb: ActionVerb;
};

export type AddMembersToScienceOrganisationInput = {
  /** New member ids */
  newMemberIds: Array<Scalars['ID']['input']>;
};

/** address */
export type Address = {
  __typename?: 'Address';
  /** City */
  city: Scalars['String']['output'];
  /** Country */
  country: Scalars['String']['output'];
  /** House number */
  houseNumber: Scalars['String']['output'];
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** Street */
  street: Scalars['String']['output'];
  /** Zip code */
  zipCode: Scalars['String']['output'];
};

export type AddressDto = {
  /** City */
  city: Scalars['String']['input'];
  /** Country */
  country: Scalars['String']['input'];
  /** House number */
  houseNumber: Scalars['String']['input'];
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street */
  street: Scalars['String']['input'];
  /** Zip code */
  zipCode: Scalars['String']['input'];
};

export enum AgeRange {
  Range06_08 = 'Range06_08',
  Range09_12 = 'Range09_12',
  Range13_15 = 'Range13_15',
  Range16_18 = 'Range16_18',
  Range18Plus = 'Range18Plus'
}

export type AppInfo = {
  __typename?: 'AppInfo';
  /** App type */
  appType: Scalars['String']['output'];
  /** Configuration */
  configuration?: Maybe<ResourceJson>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Id */
  id: Scalars['String']['output'];
  /** Item type */
  itemType: Scalars['String']['output'];
  /** Url */
  url: Scalars['String']['output'];
};

/** artefact */
export type Artefact = {
  __typename?: 'Artefact';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Age ranges */
  ageRanges: Array<AgeRange>;
  /** Child artefact ids */
  childArtefactIds: Array<Scalars['ID']['output']>;
  /** Child artefacts */
  childArtefacts: Array<Artefact>;
  /** Content element ids */
  contentElementIds: Array<Scalars['ID']['output']>;
  /** Content element ids with warnings */
  contentElementIdsWithWarnings?: Maybe<Array<Scalars['String']['output']>>;
  /** Content elements */
  contentElements: Array<ContentElement>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Domains */
  domains: Array<Domain>;
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** Parent artefact */
  parentArtefact?: Maybe<Artefact>;
  /** Parent artefact id */
  parentArtefactId?: Maybe<Scalars['ID']['output']>;
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Sequence number */
  sequenceNumber: Scalars['Int']['output'];
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescription>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
};

/** artefact-route */
export type ArtefactRoute = {
  __typename?: 'ArtefactRoute';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Artefact ids */
  artefactIds: Array<Scalars['ID']['output']>;
  /** Artefacts */
  artefacts: Array<Artefact>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Sequence number */
  sequenceNumber: Scalars['Int']['output'];
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescription>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
};

/** artefact route and science organisation */
export type ArtefactRouteScienceOrganisation = {
  __typename?: 'ArtefactRouteScienceOrganisation';
  /** ArtefactRoute */
  artefactRoute: ArtefactRoute;
  /** Science organisation */
  scienceOrganisation: ScienceOrganisation;
};

/** artefact and science organisation */
export type ArtefactScienceOrganisation = {
  __typename?: 'ArtefactScienceOrganisation';
  /** Artefact */
  artefact: Artefact;
  /** Science organisation */
  scienceOrganisation: ScienceOrganisation;
};

/** change log */
export type ChangeLog = {
  __typename?: 'ChangeLog';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Applied at */
  appliedAt: Scalars['Timestamp']['output'];
  /** Migration file name */
  fileName: Scalars['String']['output'];
};

export type ChangePasswordInput = {
  /** Confirm password */
  confirmPassword: Scalars['String']['input'];
  /** New password */
  newPassword: Scalars['String']['input'];
  /** Old password */
  oldPassword: Scalars['String']['input'];
};

/** content element and artefact */
export type ChildArtefactArtefact = {
  __typename?: 'ChildArtefactArtefact';
  /** Artefact */
  artefact: Artefact;
  /** Child artefact */
  childArtefact: Artefact;
};

export type CollectionIndices = {
  __typename?: 'CollectionIndices';
  /** Indices */
  indices: Array<IndexDefinition2>;
  /** Name */
  name: Scalars['String']['output'];
};

export type CollectionOverview = {
  __typename?: 'CollectionOverview';
  /** Total number of bytes */
  bytes?: Maybe<Scalars['Int']['output']>;
  /** Total number of kilobytes */
  kilobytes?: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Nr of disabled objects */
  nrOfDisabledObjects: Scalars['Int']['output'];
  /** Nr of enabled objects */
  nrOfEnabledObjects: Scalars['Int']['output'];
  /** Nr of not trashed objects */
  nrOfNotTrashedObjects: Scalars['Int']['output'];
  /** Nr of objects */
  nrOfObjects: Scalars['Int']['output'];
  /** Nr of trashed objects */
  nrOfTrashedObjects: Scalars['Int']['output'];
  /** Nr of usable objects */
  nrOfUsableObjects: Scalars['Int']['output'];
};

/** contentElement */
export type ContentElement = {
  __typename?: 'ContentElement';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Age ranges */
  ageRanges: Array<AgeRange>;
  /** At Home */
  atHome?: Maybe<Scalars['Boolean']['output']>;
  /** Configuration */
  configuration?: Maybe<Scalars['JSON']['output']>;
  /** Content id */
  contentId: Scalars['String']['output'];
  /** Content plugin */
  contentPlugin: ContentPlugin;
  /** Content plugin id */
  contentPluginId: Scalars['ID']['output'];
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** During visit */
  duringVisit?: Maybe<Scalars['Boolean']['output']>;
  /** Feedback body */
  feedbackBody?: Maybe<Scalars['String']['output']>;
  /** Feedback title */
  feedbackTitle?: Maybe<Scalars['String']['output']>;
  /** Language */
  language: Scalars['String']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Self report type */
  selfReportType?: Maybe<SelfReportType>;
  /** Sequence number */
  sequenceNumber: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
};

/** content element and artefact */
export type ContentElementArtefact = {
  __typename?: 'ContentElementArtefact';
  /** Artefact */
  artefact: Artefact;
  /** Content Element */
  contentElement: ContentElement;
};

/** contentElementState */
export type ContentElementState = {
  __typename?: 'ContentElementState';
  /** Content element */
  contentElement: ContentElement;
  /** Content state */
  contentState?: Maybe<ContentState>;
};

/** contentPlugin */
export type ContentPlugin = {
  __typename?: 'ContentPlugin';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Application name */
  applicationName: Scalars['String']['output'];
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Editor url */
  editorUrl: Scalars['String']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Resource type */
  resourceType: Scalars['String']['output'];
  /** Sequence number */
  sequenceNumber: Scalars['Int']['output'];
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescription>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
  /** Use in chaser */
  useInChaser: Scalars['Boolean']['output'];
  /** Use in results */
  useInResults: Scalars['Boolean']['output'];
  /** Viewer url */
  viewerUrl: Scalars['String']['output'];
};

/** contentState */
export type ContentState = {
  __typename?: 'ContentState';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Account id */
  accountId: Scalars['ID']['output'];
  /** Content element */
  contentElement: ContentElement;
  /** Content element id */
  contentElementId: Scalars['ID']['output'];
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** State */
  state?: Maybe<Scalars['JSON']['output']>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
};

export type CreateAccountInput = {
  /** Accepted legal terms */
  acceptedLegalTerms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Account type */
  accountType: AccountType;
  /** Age range */
  ageRange: AgeRange;
  /** Alternative languages */
  alternativeLanguages: Array<Scalars['String']['input']>;
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Gender */
  gender: Gender;
  /** Is test account */
  isTestAccount: Scalars['Boolean']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Login name */
  loginName: Scalars['String']['input'];
  /** Password */
  password: Scalars['String']['input'];
  /** Password type */
  passwordType: PasswordType;
  /** Preferred language */
  preferredLanguage: Scalars['String']['input'];
  /** Should change password */
  shouldChangePassword?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateArtefactInput = {
  /** Age ranges */
  ageRanges: Array<AgeRange>;
  /** Child artefact ids */
  childArtefactIds: Array<Scalars['ID']['input']>;
  /** Content element ids */
  contentElementIds: Array<Scalars['ID']['input']>;
  /** Domains */
  domains: Array<Domain>;
  /** Parent artefact id */
  parentArtefactId?: InputMaybe<Scalars['ID']['input']>;
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto>;
};

export type CreateArtefactRouteInput = {
  /** Artefact ids */
  artefactIds: Array<Scalars['ID']['input']>;
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto>;
};

export type CreateContentElementInput = {
  /** Age ranges */
  ageRanges: Array<AgeRange>;
  /** At Home */
  atHome?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** Content id */
  contentId: Scalars['String']['input'];
  /** Content plugin id */
  contentPluginId: Scalars['ID']['input'];
  /** Description */
  description: Scalars['String']['input'];
  /** During visit */
  duringVisit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Feedback body */
  feedbackBody?: InputMaybe<Scalars['String']['input']>;
  /** Feedback title */
  feedbackTitle?: InputMaybe<Scalars['String']['input']>;
  /** Language */
  language: Scalars['String']['input'];
  /** Self report type */
  selfReportType?: InputMaybe<SelfReportType>;
  /** Title */
  title: Scalars['String']['input'];
};

export type CreateContentPluginInput = {
  /** Application name */
  applicationName: Scalars['String']['input'];
  /** Editor url */
  editorUrl: Scalars['String']['input'];
  /** Resource type */
  resourceType: Scalars['String']['input'];
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto>;
  /** Use in chaser */
  useInChaser: Scalars['Boolean']['input'];
  /** Use in results */
  useInResults: Scalars['Boolean']['input'];
  /** Viewer url */
  viewerUrl: Scalars['String']['input'];
};

export type CreateContentStateInput = {
  /** Account id */
  accountId: Scalars['ID']['input'];
  /** Content element id */
  contentElementId: Scalars['ID']['input'];
  /** State */
  state?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateQrCodeInput = {
  /** Target Id */
  targetId: Scalars['ID']['input'];
  /** Target type */
  targetType: QrCodeTargetType;
};

export type CreateScienceOrganisationInput = {
  /** Location */
  location: LocationDto;
  /** Logo url */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Member ids */
  memberIds: Array<Scalars['ID']['input']>;
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto>;
  /** Website url */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSelfReportInput = {
  /** content element id */
  contentElementId?: InputMaybe<Scalars['ID']['input']>;
  /** Description of the report */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Url of the material */
  materialUrl?: InputMaybe<Scalars['String']['input']>;
  /** Strands */
  strands: StrandsInput;
  /** Title of the report */
  title: Scalars['String']['input'];
  /** Type of the report */
  type: SelfReportType;
};

export enum Domain {
  Astronomy = 'Astronomy',
  Biology = 'Biology',
  Chemistry = 'Chemistry',
  Engineering = 'Engineering',
  Mathematics = 'Mathematics',
  Physics = 'Physics',
  Programming = 'Programming'
}

export type EnableNotificationDto = {
  /** Device ID */
  deviceId: Scalars['String']['input'];
};

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
  PreferNotToSay = 'PreferNotToSay'
}

export type Generator = {
  __typename?: 'Generator';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Id */
  id: Scalars['String']['output'];
  /** Object type */
  objectType: Scalars['String']['output'];
  /** Url */
  url: Scalars['String']['output'];
};

export type GeneratorInput = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Id */
  id: Scalars['String']['input'];
  /** Object type */
  objectType: Scalars['String']['input'];
  /** Url */
  url: Scalars['String']['input'];
};

/**  gps location */
export type GpsLocation = {
  __typename?: 'GpsLocation';
  /** Latitude */
  latitude: Scalars['String']['output'];
  /** Longitude */
  longitude: Scalars['String']['output'];
};

export type GpsLocationDto = {
  /** Latitude */
  latitude: Scalars['String']['input'];
  /** Longitude */
  longitude: Scalars['String']['input'];
};

/** High score entry */
export type HighScoreEntry = {
  __typename?: 'HighScoreEntry';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Current streak */
  currentStreak: Scalars['Int']['output'];
  /** Login name */
  loginName: Scalars['String']['output'];
  /** Longest streak */
  longestStreak: Scalars['Int']['output'];
  /** Total score */
  totalScore: Scalars['Int']['output'];
};

export type IlsStructure = {
  __typename?: 'IlsStructure';
  /** List of global apps */
  apps: Array<AppInfo>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Id */
  id: Scalars['String']['output'];
  /** Learning analytics enabled */
  ilsHasAngeLA: Scalars['Boolean']['output'];
  /** Ils id */
  ilsId: Scalars['String']['output'];
  /** Can be run offline */
  offlineSupport: Scalars['Boolean']['output'];
  /** List of phases */
  phases: Array<PhaseStructure>;
  /** Url */
  url: Scalars['String']['output'];
};

export type IlsStructureJson = {
  __typename?: 'IlsStructureJson';
  /** ILS structure */
  ilsStructure: Scalars['JSON']['output'];
};

export type IndexDefinition2 = {
  __typename?: 'IndexDefinition2';
  /** Fields */
  fields: Array<KeyValue>;
  /** Options */
  options: Array<KeyValue>;
};

/** Key with count */
export type KeyCount = {
  __typename?: 'KeyCount';
  /** Count */
  count: Scalars['Int']['output'];
  /** Key */
  key: Scalars['String']['output'];
};

export type KeyValue = {
  __typename?: 'KeyValue';
  /** Key */
  key: Scalars['String']['output'];
  /** Value */
  value: Scalars['String']['output'];
};

/** location */
export type Location = {
  __typename?: 'Location';
  /** address */
  address?: Maybe<Address>;
  /** gps location */
  gpsLocation?: Maybe<GpsLocation>;
  /** Location type */
  locationType: LocationType;
};

export type LocationDto = {
  /** address */
  address?: InputMaybe<AddressDto>;
  /** gps location */
  gpsLocation?: InputMaybe<GpsLocationDto>;
  /** Location type */
  locationType: LocationType;
};

export enum LocationType {
  Address = 'Address',
  Home = 'Home',
  Outdoor = 'Outdoor',
  School = 'School',
  ScienceOrganisation = 'ScienceOrganisation'
}

export type LogAccessorQueryResultJson = {
  __typename?: 'LogAccessorQueryResultJson';
  /** log accessor query results */
  logAccessorQueryResults: Scalars['JSON']['output'];
};

/** log action */
export type LogAction = {
  __typename?: 'LogAction';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Creator */
  actor: Account;
  /** Actor id */
  actorId: Scalars['ID']['output'];
  /** Action location */
  app: ActionApp;
  /** Client date */
  clientDate: Scalars['Timestamp']['output'];
  /** Description of action */
  description?: Maybe<Scalars['JSON']['output']>;
  /** Server date */
  serverDate: Scalars['Timestamp']['output'];
  /** Session sequence number */
  sessionSequenceNumber: Scalars['Int']['output'];
  /** Target id */
  targetId: Scalars['ID']['output'];
  /** Target type */
  targetType: TargetTypes;
  /** Action verb */
  verb: ActionVerb;
};

export type LogActionActorQueryInput = {
  /** Actor ids */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Object type */
  objectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LogActionBasicProjectionInput = {
  /** Display name */
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object id */
  id?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object type */
  objectType?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogActionGeneratorProjectionInput = {
  /** Display name */
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object id */
  id?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object type */
  objectType?: InputMaybe<Scalars['Boolean']['input']>;
  /** Url */
  url?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogActionGeneratorQueryInput = {
  /** Generator ids */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Log action key counts */
export type LogActionKeyCounts = {
  __typename?: 'LogActionKeyCounts';
  /** Nr of log action summaries per action app */
  nrsPerActionApp: Array<KeyCount>;
  /** Nr of log action summaries per action verb */
  nrsPerActionVerb: Array<KeyCount>;
  /** Nr of log action summaries per science organisation id */
  nrsPerScienceOrganisationId: Array<KeyCount>;
  /** Nr of log action summaries per target type */
  nrsPerTargetType: Array<KeyCount>;
  /** Total nr of log action summaries */
  totalNr: Scalars['Int']['output'];
};

export type LogActionObjectProjectionInput = {
  /** Content */
  content?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id */
  id?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object type */
  objectType?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogActionObjectTypeQueryInput = {
  /** Object type */
  objectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LogActionProjectionJsonInput = {
  /** Actor projections */
  actor?: InputMaybe<LogActionBasicProjectionInput>;
  /** All actor fields */
  actorAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** App sequence number */
  appSequenceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** Generator projections */
  generator?: InputMaybe<LogActionGeneratorProjectionInput>;
  /** All generator fields */
  generatorAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object projections */
  object?: InputMaybe<LogActionObjectProjectionInput>;
  /** All object fields */
  objectAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Provider projections */
  provider?: InputMaybe<LogActionProviderProjectionInput>;
  /** All provider fields */
  providerAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Client time */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Server time */
  publishedServer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Session sequence number */
  sessionSequenceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target projections */
  target?: InputMaybe<LogActionBasicProjectionInput>;
  /** All target fields */
  targetAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Verb */
  verb?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogActionProviderProjectionInput = {
  /** ILS has angela */
  ilsHasAngeLA?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inquiry phase */
  inquiryPhase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inquiry id */
  inquiryPhaseId?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inquiry name */
  inquiryPhaseName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Url */
  url?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogActionProviderQueryInput = {
  /** Phase ids */
  inquiryPhaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LogActionQuery = {
  /** Action apps */
  actionApps?: InputMaybe<Array<ActionApp>>;
  /** Action verbs */
  actionVerbs?: InputMaybe<Array<ActionVerb>>;
  /** End date */
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Science organisation ids */
  scienceOrganisationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date */
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Target types */
  targetTypes?: InputMaybe<Array<TargetTypes>>;
};

export type LogActionQueryJsonInput = {
  /** Actor query */
  actor?: InputMaybe<LogActionActorQueryInput>;
  /** Generator query */
  generator?: InputMaybe<LogActionGeneratorQueryInput>;
  /** max nr of results */
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  /** Object query */
  object?: InputMaybe<LogActionObjectTypeQueryInput>;
  /** page number */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Provider query */
  provider?: InputMaybe<LogActionProviderQueryInput>;
  /** Client time */
  published?: InputMaybe<LogActionTimeQueryInput>;
  /** Server time */
  publishedServer?: InputMaybe<LogActionTimeQueryInput>;
  /** Target query */
  target?: InputMaybe<LogActionObjectTypeQueryInput>;
  /** Verbs */
  verbs?: InputMaybe<Array<NextlabVerbs>>;
};

/** Log action summaries */
export type LogActionSummaries = {
  __typename?: 'LogActionSummaries';
  /** Log action summaries */
  logActionSummaries: Array<LogActionSummary>;
  /** Nr of log action summaries per action app */
  nrsPerActionApp: Array<KeyCount>;
  /** Nr of log action summaries per action verb */
  nrsPerActionVerb: Array<KeyCount>;
  /** Nr of log action summaries per target type */
  nrsPerTargetType: Array<KeyCount>;
  /** Total nr of log action summaries */
  totalNr: Scalars['Int']['output'];
};

/** Log action summary */
export type LogActionSummary = {
  __typename?: 'LogActionSummary';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Action location */
  app: ActionApp;
  /** Client date */
  clientDate: Scalars['Timestamp']['output'];
  /** Actor login name */
  loginName: Scalars['ID']['output'];
  /** Server date */
  serverDate: Scalars['Timestamp']['output'];
  /** Session sequence number */
  sessionSequenceNumber: Scalars['Int']['output'];
  /** Target type */
  targetType: TargetTypes;
  /** Action verb */
  verb: ActionVerb;
};

export type LogActionTimeQueryInput = {
  /** End time */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Start time */
  start?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataJson = {
  __typename?: 'MetadataJSON';
  /** Actor */
  actor: Actor;
  /** Flags */
  flags?: Maybe<Scalars['JSON']['output']>;
  /** Generator */
  generator: Generator;
  /** Provider */
  provider: Provider;
  /** Published client date */
  published?: Maybe<Scalars['Timestamp']['output']>;
  /** Published server date */
  publishedServer?: Maybe<Scalars['Timestamp']['output']>;
  /** Target */
  target: Target;
};

export type MetadataJsonInput = {
  /** Actor */
  actor: ActorInput;
  /** Flags */
  flags?: InputMaybe<Scalars['JSON']['input']>;
  /** Generator */
  generator: GeneratorInput;
  /** Provider */
  provider: ProviderInput;
  /** Published client date */
  published?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Published server date */
  publishedServer?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Target */
  target: TargetInput;
};

export type MongoDbVersion = {
  __typename?: 'MongoDbVersion';
  /** MongoDB status */
  ok: Scalars['Float']['output'];
  /** Openssl compiled version */
  openSslCompiledVersion: Scalars['String']['output'];
  /** Openssl running version */
  openSslRunningVersion: Scalars['String']['output'];
  /** Version */
  version: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addArtefactRouteToScienceOrganisation: ArtefactRouteScienceOrganisation;
  addArtefactToScienceOrganisation: ArtefactScienceOrganisation;
  addChildArtefactToArtefact: ChildArtefactArtefact;
  addContentElementToArtefact: ContentElementArtefact;
  addLogAction: LogAction;
  addMembersToScienceOrganisation: ScienceOrganisation;
  addSelfReportToAccount: AccountNewHighscore;
  changePassword: Account;
  createAccount: Account;
  createContentElement: ContentElement;
  createContentPlugin: ContentPlugin;
  createContentState: ContentState;
  createQrCode: QrCode;
  createScienceOrganisation: ScienceOrganisation;
  disableAccount: Account;
  disableArtefact: Artefact;
  disableArtefactRoute: ArtefactRoute;
  disableContentElement: ContentElement;
  disableContentPlugin: ContentPlugin;
  disableNotifications: Account;
  disableScienceOrganisation: ScienceOrganisation;
  duplicateArtefactInScienceOrganisation: ArtefactScienceOrganisation;
  duplicateContentElementInArtefact: ContentElementArtefact;
  enableAccount: Account;
  enableArtefact: Artefact;
  enableArtefactRoute: ArtefactRoute;
  enableContentElement: ContentElement;
  enableContentPlugin: ContentPlugin;
  enableNotifications: Account;
  enableScienceOrganisation: ScienceOrganisation;
  moveArtefactRouteToTrash: ArtefactRoute;
  moveArtefactToTrash: Artefact;
  moveContentElementToTrash: ContentElement;
  moveContentPluginToTrash: ContentPlugin;
  moveScienceOrganisationToTrash: ScienceOrganisation;
  orderArtefactRoutes: Array<ArtefactRoute>;
  orderArtefacts: Array<Artefact>;
  orderContentElements: Array<ContentElement>;
  orderContentPlugins: Array<ContentPlugin>;
  orderScienceOrganisations: Array<ScienceOrganisation>;
  removeArtefact: Artefact;
  removeArtefactRoute: ArtefactRoute;
  removeArtefactsFromScienceOrganisation: ScienceOrganisation;
  removeChildArtefactsFromArtefact: Artefact;
  removeContentElement: ContentElement;
  removeContentElementsFromArtefact: Artefact;
  removeContentPlugin: ContentPlugin;
  removeContentState: ContentState;
  removeMembersFromScienceOrganisation: ScienceOrganisation;
  removeScienceOrganisation: ScienceOrganisation;
  retrieveArtefactFromTrash: Artefact;
  retrieveArtefactRouteFromTrash: ArtefactRoute;
  retrieveContentElementFromTrash: ContentElement;
  retrieveContentPluginFromTrash: ContentPlugin;
  retrieveScienceOrganisationFromTrash: ScienceOrganisation;
  sendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDays: Notification;
  sendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDays: Notification;
  sendGenericActivityReminderToEveryone: Notification;
  sendNotification: Notification;
  sendStreakAboutToExpireToEveryone: Notification;
  sendStreakReminderToEveryone: Notification;
  updateAccount: Account;
  updateArtefact: Artefact;
  updateArtefactRoute: ArtefactRoute;
  updateContentElement: ContentElement;
  updateContentPlugin: ContentPlugin;
  updateContentState: ContentState;
  updateScienceOrganisation: ScienceOrganisation;
};


export type MutationAddArtefactRouteToScienceOrganisationArgs = {
  createArtefactRouteInput: CreateArtefactRouteInput;
  id: Scalars['ID']['input'];
};


export type MutationAddArtefactToScienceOrganisationArgs = {
  createArtefactInput: CreateArtefactInput;
  id: Scalars['ID']['input'];
};


export type MutationAddChildArtefactToArtefactArgs = {
  createArtefactInput: CreateArtefactInput;
  id: Scalars['ID']['input'];
};


export type MutationAddContentElementToArtefactArgs = {
  createContentElementInput: CreateContentElementInput;
  id: Scalars['ID']['input'];
};


export type MutationAddLogActionArgs = {
  addLogActionInput: AddLogActionInput;
};


export type MutationAddMembersToScienceOrganisationArgs = {
  addMembersToScienceOrganisationInput: AddMembersToScienceOrganisationInput;
  id: Scalars['ID']['input'];
};


export type MutationAddSelfReportToAccountArgs = {
  createSelfReportInput: CreateSelfReportInput;
  id: Scalars['ID']['input'];
};


export type MutationChangePasswordArgs = {
  changePasswordInput: ChangePasswordInput;
  id: Scalars['ID']['input'];
};


export type MutationCreateAccountArgs = {
  createAccountInput: CreateAccountInput;
};


export type MutationCreateContentElementArgs = {
  createContentElementInput: CreateContentElementInput;
};


export type MutationCreateContentPluginArgs = {
  createContentPluginInput: CreateContentPluginInput;
};


export type MutationCreateContentStateArgs = {
  createContentStateInput: CreateContentStateInput;
};


export type MutationCreateQrCodeArgs = {
  createQrCodeInput: CreateQrCodeInput;
};


export type MutationCreateScienceOrganisationArgs = {
  createScienceOrganisationInput: CreateScienceOrganisationInput;
};


export type MutationDisableAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableArtefactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableArtefactRouteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableContentElementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableContentPluginArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableNotificationsArgs = {
  dto: EnableNotificationDto;
};


export type MutationDisableScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateArtefactInScienceOrganisationArgs = {
  artefactId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDuplicateContentElementInArtefactArgs = {
  contentElementId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationEnableAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableArtefactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableArtefactRouteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableContentElementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableContentPluginArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableNotificationsArgs = {
  dto: EnableNotificationDto;
};


export type MutationEnableScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveArtefactRouteToTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveArtefactToTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveContentElementToTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveContentPluginToTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveScienceOrganisationToTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrderArtefactRoutesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationOrderArtefactsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationOrderContentElementsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationOrderContentPluginsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationOrderScienceOrganisationsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRemoveArtefactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveArtefactRouteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveArtefactsFromScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
  oldArtefactIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveChildArtefactsFromArtefactArgs = {
  id: Scalars['ID']['input'];
  oldArtefactIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveContentElementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContentElementsFromArtefactArgs = {
  id: Scalars['ID']['input'];
  oldContentElementIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveContentPluginArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContentStateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveMembersFromScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
  removeMembersFromScienceOrganisationInput: RemoveMembersFromScienceOrganisationInput;
};


export type MutationRemoveScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveArtefactFromTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveArtefactRouteFromTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveContentElementFromTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveContentPluginFromTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveScienceOrganisationFromTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendNotificationArgs = {
  notification: SendNotificationDto;
};


export type MutationUpdateAccountArgs = {
  id: Scalars['ID']['input'];
  updateAccountInput: UpdateAccountInput;
};


export type MutationUpdateArtefactArgs = {
  id: Scalars['ID']['input'];
  updateArtefactInput: UpdateArtefactInput;
};


export type MutationUpdateArtefactRouteArgs = {
  id: Scalars['ID']['input'];
  updateArtefactRouteInput: UpdateArtefactRouteInput;
};


export type MutationUpdateContentElementArgs = {
  id: Scalars['ID']['input'];
  updateContentElementInput: UpdateContentElementInput;
};


export type MutationUpdateContentPluginArgs = {
  id: Scalars['ID']['input'];
  updateContentPluginInput: UpdateContentPluginInput;
};


export type MutationUpdateContentStateArgs = {
  id: Scalars['ID']['input'];
  updateContentStateInput: UpdateContentStateInput;
};


export type MutationUpdateScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
  updateScienceOrganisationInput: UpdateScienceOrganisationInput;
};

/** New highscore */
export type NewHighScore = {
  __typename?: 'NewHighScore';
  /** New longest streak */
  newLongestStreak: Scalars['Boolean']['output'];
  /** The new streak value, if updated */
  newStreakValue?: Maybe<Scalars['Float']['output']>;
  /** Reported fifty activities */
  reportedFiftyActivities: Scalars['Boolean']['output'];
  /** Reported five activities */
  reportedFiveActivities: Scalars['Boolean']['output'];
  /** Reported one activity */
  reportedOneActivity: Scalars['Boolean']['output'];
  /** Reported one hundred activities */
  reportedOneHundredActivities: Scalars['Boolean']['output'];
  /** Reported ten activities */
  reportedTenActivities: Scalars['Boolean']['output'];
  /** Reported twenty five activities */
  reportedTwentyFiveActivities: Scalars['Boolean']['output'];
  /** Updated streak */
  updatedStreak: Scalars['Boolean']['output'];
};

export enum NextlabVerbs {
  Access = 'access',
  Add = 'add',
  ApplicationStarted = 'application_started',
  ApplicationStopped = 'application_stopped',
  Cancel = 'cancel',
  Change = 'change',
  Clear = 'clear',
  Create = 'create',
  Delete = 'delete',
  New = 'new',
  Open = 'open',
  PhaseChanged = 'phase_changed',
  Receive = 'receive',
  Remove = 'remove',
  Send = 'send',
  Start = 'start',
  Update = 'update'
}

/** notification */
export type Notification = {
  __typename?: 'Notification';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Account ids who received notification */
  accountsWhoReceivedNotifications: Array<Account>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** Notification payload */
  payload: NotificationPayload;
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Account ids who received notification */
  sentToAccountIds: Array<Scalars['ID']['output']>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Type of notification */
  type: SbsNotificationType;
  /** Url */
  url: Scalars['String']['output'];
};

/** notification payload */
export type NotificationPayload = {
  __typename?: 'NotificationPayload';
  /** Language */
  body: Scalars['String']['output'];
  /** Configuration */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Language */
  icon: Scalars['String']['output'];
  /** Language */
  title: Scalars['String']['output'];
};

/** Nr of accounts */
export type NrOfAccounts = {
  __typename?: 'NrOfAccounts';
  /** Nr of disabled accounts */
  nrOfDisabledAccounts: Scalars['Int']['output'];
  /** Nr of disabled administrators */
  nrOfDisabledAdministrators: Scalars['Int']['output'];
  /** Nr of disabled participants */
  nrOfDisabledParticipants: Scalars['Int']['output'];
  /** Nr of disabled projectMembers */
  nrOfDisabledProjectMembers: Scalars['Int']['output'];
  /** Nr of enabled accounts */
  nrOfEnabledAccounts: Scalars['Int']['output'];
  /** Nr of enabled administrators */
  nrOfEnabledAdministrators: Scalars['Int']['output'];
  /** Nr of enabled participants */
  nrOfEnabledParticipants: Scalars['Int']['output'];
  /** Nr of enabled projectMembers */
  nrOfEnabledProjectMembers: Scalars['Int']['output'];
};

/** Nr of log actions */
export type NrOfLogActions = {
  __typename?: 'NrOfLogActions';
  /** Nr of chaser log actions */
  nrOfChaserLogActions: Scalars['Int']['output'];
  /** Nr of digital toolbox manager log actions */
  nrOfDigitalToolboxManagerLogActions: Scalars['Int']['output'];
  /** Nr of server log actions */
  nrOfServerLogActions: Scalars['Int']['output'];
};

export enum PasswordType {
  Apple = 'Apple',
  Facebook = 'Facebook',
  Google = 'Google',
  Local = 'Local'
}

export type PhaseStructure = {
  __typename?: 'PhaseStructure';
  /** List of global apps */
  apps: Array<AppInfo>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Id */
  id: Scalars['String']['output'];
  /** Type */
  type: Scalars['String']['output'];
  /** Visibility level */
  visibilityLevel: Scalars['String']['output'];
};

export type Provider = {
  __typename?: 'Provider';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Id */
  id: Scalars['String']['output'];
  /** Learning analytics enabled */
  ilsHasAngeLA: Scalars['Boolean']['output'];
  /** Inquire phase */
  inquiryPhase: Scalars['String']['output'];
  /** Inquire phase id */
  inquiryPhaseId: Scalars['String']['output'];
  /** Inquire phase name */
  inquiryPhaseName: Scalars['String']['output'];
  /** Object type */
  objectType: Scalars['String']['output'];
  /** Url */
  url: Scalars['String']['output'];
};

export type ProviderInput = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Id */
  id: Scalars['String']['input'];
  /** Learning analytics enabled */
  ilsHasAngeLA: Scalars['Boolean']['input'];
  /** Inquire phase */
  inquiryPhase: Scalars['String']['input'];
  /** Inquire phase id */
  inquiryPhaseId: Scalars['String']['input'];
  /** Inquire phase name */
  inquiryPhaseName: Scalars['String']['input'];
  /** Object type */
  objectType: Scalars['String']['input'];
  /** Url */
  url: Scalars['String']['input'];
};

/** QR code */
export type QrCode = {
  __typename?: 'QrCode';
  /** Id */
  _id: Scalars['ID']['output'];
  /** code */
  code: Scalars['String']['output'];
  /** Target Id */
  targetId: Scalars['ID']['output'];
  /** Qr code target type */
  targetType: QrCodeTargetType;
};

/** QR code description */
export type QrCodeDescription = {
  __typename?: 'QrCodeDescription';
  /** Artefact */
  artefact?: Maybe<Artefact>;
  /** Artefact id */
  artefactId?: Maybe<Scalars['ID']['output']>;
  /** ArtefactRoute */
  artefactRoute?: Maybe<ArtefactRoute>;
  /** Artefact route id */
  artefactRouteId?: Maybe<Scalars['ID']['output']>;
  /** ContentElement */
  contentElement?: Maybe<ContentElement>;
  /** Content element id */
  contentElementId?: Maybe<Scalars['ID']['output']>;
  /** Science organisation */
  scienceOrganisation: ScienceOrganisation;
  /** Science organisation id */
  scienceOrganisationId?: Maybe<Scalars['ID']['output']>;
  /** Target type */
  targetType: QrCodeTargetType;
};

export enum QrCodeTargetType {
  Artefact = 'Artefact',
  ArtefactRoute = 'ArtefactRoute',
  ContentElement = 'ContentElement',
  ScienceOrganisation = 'ScienceOrganisation'
}

export type Query = {
  __typename?: 'Query';
  findQrCodeDescription: QrCodeDescription;
  getAccountById: Account;
  getAccountByName: Account;
  getAccounts: Array<Account>;
  getAccountsForScienceOrganisation: Scalars['String']['output'];
  getAllContentElements: Array<ContentElement>;
  getAllContentPlugins: Array<ContentPlugin>;
  getAllContentStates: Array<ContentState>;
  getAllScienceOrganisations: Array<ScienceOrganisation>;
  getAllSelfReports: Array<SelfReport>;
  getAllSelfReportsExcelWithAccountInfo: Scalars['String']['output'];
  getAllTrashedContentElements: Array<ContentElement>;
  getAllTrashedContentPlugins: Array<ContentPlugin>;
  getAllTrashedScienceOrganisations: Array<ScienceOrganisation>;
  getArtefactById: Artefact;
  getArtefactRouteById: ArtefactRoute;
  getCollectionIndices: Array<CollectionIndices>;
  getContentElementById: ContentElement;
  getContentElementState: ContentElementState;
  getContentPluginById: ContentPlugin;
  getContentStateById: ContentState;
  getHighScoreList: Array<HighScoreEntry>;
  getIlsStructure: IlsStructure;
  getIlsStructureJson: IlsStructureJson;
  getLogActionById: LogAction;
  getLogActionKeyCounts: LogActionKeyCounts;
  getLogActionSummaries: LogActionSummaries;
  getLogActionsByQuery: Array<LogAction>;
  getLogActionsByVerbs: Array<LogAction>;
  getMigrations: Array<ChangeLog>;
  getNotificationById: Notification;
  getNotifications: Array<Notification>;
  getNrOfAccounts: NrOfAccounts;
  getNrOfLogActions: NrOfLogActions;
  getScienceOrganisationById: ScienceOrganisation;
  getSelfReportById: SelfReport;
  getServerStatus: ServerStatus;
  getStorageStatusOverview: StorageStatusOverview;
  getUsersWithNotificationsEnabled: Array<Account>;
  queryResources: Array<ResourceJson>;
  queryResourcesJson: ResourceQueryResultJson;
  readResource: ResourceJson;
  readResourceJson: ResourceReadResultJson;
  retrieveActors: Array<Actor>;
  retrieveLogActions: Array<ActivityStreamObject>;
  retrieveLogActionsJson: LogAccessorQueryResultJson;
  updateResource: ResourceJson;
  updateResourceJson: ResourceUpdateResultJson;
};


export type QueryFindQrCodeDescriptionArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetAccountByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAccountByNameArgs = {
  loginName: Scalars['String']['input'];
};


export type QueryGetAccountsArgs = {
  accountQuery?: InputMaybe<AccountQuery>;
};


export type QueryGetAccountsForScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetArtefactByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetArtefactRouteByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetContentElementByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetContentElementStateArgs = {
  accountId: Scalars['ID']['input'];
  contentElementId: Scalars['ID']['input'];
};


export type QueryGetContentPluginByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetContentStateByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetHighScoreListArgs = {
  nrOfAccounts: Scalars['Int']['input'];
  sortBy: Scalars['String']['input'];
};


export type QueryGetIlsStructureArgs = {
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryGetIlsStructureJsonArgs = {
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryGetLogActionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLogActionKeyCountsArgs = {
  logActionQuery: LogActionQuery;
};


export type QueryGetLogActionSummariesArgs = {
  logActionSummaryQuery: LogActionQuery;
};


export type QueryGetLogActionsByQueryArgs = {
  lastLogActionId?: InputMaybe<Scalars['String']['input']>;
  logActionSummaryQuery: LogActionQuery;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryGetLogActionsByVerbsArgs = {
  verbs: Array<ActionVerb>;
};


export type QueryGetNotificationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetScienceOrganisationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSelfReportByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQueryResourcesArgs = {
  resourceQueryJSON: ResourceQueryJson;
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryQueryResourcesJsonArgs = {
  resourceQueryJSON: ResourceQueryJson;
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryReadResourceArgs = {
  resourceId: Scalars['ID']['input'];
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryReadResourceJsonArgs = {
  resourceId: Scalars['ID']['input'];
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryRetrieveLogActionsArgs = {
  logActionProjectionJSONInput: LogActionProjectionJsonInput;
  logActionQueryJSONInput: LogActionQueryJsonInput;
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryRetrieveLogActionsJsonArgs = {
  logActionProjectionJSONInput: LogActionProjectionJsonInput;
  logActionQueryJSONInput: LogActionQueryJsonInput;
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryUpdateResourceArgs = {
  resource: ResourceJsonInput;
};


export type QueryUpdateResourceJsonArgs = {
  resource: ResourceJsonInput;
};

export type RemoveMembersFromScienceOrganisationInput = {
  /** Old member ids */
  oldMemberIds: Array<Scalars['ID']['input']>;
};

export type ResourceJson = {
  __typename?: 'ResourceJSON';
  /** Content */
  content?: Maybe<Scalars['JSON']['output']>;
  /** Metadata */
  metadata: MetadataJson;
};

export type ResourceJsonInput = {
  /** Content */
  content?: InputMaybe<Scalars['JSON']['input']>;
  /** Metadata */
  metadata: MetadataJsonInput;
};

export type ResourceQueryJson = {
  /** actor id */
  actorId?: InputMaybe<Scalars['String']['input']>;
  /** app id */
  appId?: InputMaybe<Scalars['String']['input']>;
  /** max nr of results */
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  /** order by modification date */
  orderByModificationDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** page number */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** resource type */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** return metadata only */
  returnMetadataOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceQueryResultJson = {
  __typename?: 'ResourceQueryResultJson';
  /** resource query results */
  resourceQueryResults: Scalars['JSON']['output'];
};

export type ResourceReadResultJson = {
  __typename?: 'ResourceReadResultJson';
  /** resource read results */
  resourceReadResults: Scalars['JSON']['output'];
};

export type ResourceUpdateResultJson = {
  __typename?: 'ResourceUpdateResultJson';
  /** resource update results */
  resourceUpdateResults: Scalars['JSON']['output'];
};

export enum SbsNotificationType {
  ActivityReminder = 'ACTIVITY_REMINDER',
  ActivityReminderSevenDays = 'ACTIVITY_REMINDER_SEVEN_DAYS',
  ActivityReminderThreeDays = 'ACTIVITY_REMINDER_THREE_DAYS',
  Custom = 'CUSTOM',
  StreakAboutToExpire = 'STREAK_ABOUT_TO_EXPIRE',
  StreakReminder = 'STREAK_REMINDER'
}

/** science organisation */
export type ScienceOrganisation = {
  __typename?: 'ScienceOrganisation';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Artefact ids */
  artefactIds: Array<Scalars['ID']['output']>;
  /** Artefact route ids */
  artefactRouteIds: Array<Scalars['ID']['output']>;
  /** Artefact routes */
  artefactRoutes: Array<ArtefactRoute>;
  /** Artefacts */
  artefacts: Array<Artefact>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** Location */
  location: Location;
  /** Logo url */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** Member ids */
  memberIds: Array<Scalars['ID']['output']>;
  /** Members */
  members: Array<Account>;
  /** NotificationIds */
  notificationIds: Array<Scalars['ID']['output']>;
  /** Notifications */
  notifications: Array<Notification>;
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Sequence number */
  sequenceNumber: Scalars['Int']['output'];
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescription>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
  /** Website url */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Scores */
export type Scores = {
  __typename?: 'Scores';
  /** Current streak */
  currentStreak: Scalars['Int']['output'];
  /** Do */
  doScore: Scalars['Float']['output'];
  /** Longest streak */
  longestStreak: Scalars['Int']['output'];
  /** Read */
  readScore: Scalars['Float']['output'];
  /** Total strand scores */
  strandsScores: Strands;
  /** Visit / attend */
  visitAttendScore: Scalars['Float']['output'];
  /** Watch/listen */
  watchListenScore: Scalars['Float']['output'];
};

/** Self report */
export type SelfReport = {
  __typename?: 'SelfReport';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Content element id */
  contentElementId?: Maybe<Scalars['ID']['output']>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Description of the report */
  description?: Maybe<Scalars['String']['output']>;
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** URL of the report */
  materialUrl?: Maybe<Scalars['String']['output']>;
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** Strands */
  strands: Strands;
  /** Title of the report */
  title: Scalars['String']['output'];
  /** Type of the report */
  type: SelfReportType;
  /** Url */
  url: Scalars['String']['output'];
};

export enum SelfReportType {
  Do = 'Do',
  Read = 'Read',
  VisitAttend = 'VisitAttend',
  WatchListen = 'WatchListen'
}

export type SendNotificationDto = {
  /** Artefact id */
  artefactId?: InputMaybe<Scalars['ID']['input']>;
  /** Notification body */
  body: Scalars['String']['input'];
  /** Content element id */
  contentElementId?: InputMaybe<Scalars['ID']['input']>;
  /** Science organisation id */
  scienceOrganisationId?: InputMaybe<Scalars['ID']['input']>;
  /** Notification title */
  title: Scalars['String']['input'];
};

export type ServerStatus = {
  __typename?: 'ServerStatus';
  /** Average load */
  averageLoad: Array<Scalars['Float']['output']>;
  /** Free disk space */
  freeDiskSpace: Scalars['Int']['output'];
  /** Free memory */
  freeMemory: Scalars['Int']['output'];
  /** Number of cpus */
  nrOfCpus: Scalars['Int']['output'];
  /** OS release */
  osRelease: Scalars['String']['output'];
  /** OS type */
  osType: Scalars['String']['output'];
  /** OS version */
  osVersion: Scalars['String']['output'];
  /** Running */
  running: Scalars['Boolean']['output'];
  /** Total disk space */
  totalDiskSpace: Scalars['Int']['output'];
  /** Total memory */
  totalMemory: Scalars['Int']['output'];
  /** Uptime */
  uptime: Scalars['Int']['output'];
};

/** title and description in one language */
export type SingleLanguageTitleDescription = {
  __typename?: 'SingleLanguageTitleDescription';
  /** Description */
  description: Scalars['String']['output'];
  /** Language */
  language: Scalars['String']['output'];
  /** Title */
  title: Scalars['String']['output'];
};

export type SingleLanguageTitleDescriptionDto = {
  /** Description */
  description: Scalars['String']['input'];
  /** Language */
  language: Scalars['String']['input'];
  /** Title */
  title: Scalars['String']['input'];
};

export type StorageStatusOverview = {
  __typename?: 'StorageStatusOverview';
  /** Collection overviews */
  collectionOverviews: Array<CollectionOverview>;
  /** MongoDb version */
  mongoDbVersion: MongoDbVersion;
};

/** Strands */
export type Strands = {
  __typename?: 'Strands';
  /** I got insight into the scientific work */
  insight: Scalars['Float']['output'];
  /** It was interesting */
  interesting: Scalars['Float']['output'];
  /** I learned something new */
  learned: Scalars['Float']['output'];
  /** I saw myself as a science person */
  sciencePerson: Scalars['Float']['output'];
  /** I used science tools and language */
  scienceToolsAndLanguage: Scalars['Float']['output'];
  /** It helped me understanding something in science */
  understanding: Scalars['Float']['output'];
};

export type StrandsInput = {
  /** I got insight into the scienctific work */
  insight: Scalars['Float']['input'];
  /** It was interesting */
  interesting: Scalars['Float']['input'];
  /** I learned something new */
  learned: Scalars['Float']['input'];
  /** I saw myself as a science person */
  sciencePerson: Scalars['Float']['input'];
  /** I used science tools and language */
  scienceToolsAndLanguage: Scalars['Float']['input'];
  /** It helped me understanding something in science */
  understanding: Scalars['Float']['input'];
};

export type Target = {
  __typename?: 'Target';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** For application (only for configuration resources) */
  forApplication?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['String']['output'];
  /** Object type */
  objectType: Scalars['String']['output'];
};

export type TargetInput = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** For application (only for configuration resources) */
  forApplication?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  id: Scalars['String']['input'];
  /** Object type */
  objectType: Scalars['String']['input'];
};

export enum TargetTypes {
  Account = 'Account',
  Artefact = 'Artefact',
  ArtefactRoute = 'ArtefactRoute',
  ContentElement = 'ContentElement',
  ContentPlugin = 'ContentPlugin',
  ContentState = 'ContentState',
  Notification = 'Notification',
  OtherPage = 'OtherPage',
  ScienceOrganisation = 'ScienceOrganisation',
  SelfReport = 'SelfReport',
  Unknown = 'Unknown'
}

export type UpdateAccountInput = {
  /** Accepted legal terms */
  acceptedLegalTerms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Account type */
  accountType?: InputMaybe<AccountType>;
  /** Age range */
  ageRange?: InputMaybe<AgeRange>;
  /** Alternative languages */
  alternativeLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender */
  gender?: InputMaybe<Gender>;
  /** Is test account */
  isTestAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Login name */
  loginName?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Password type */
  passwordType?: InputMaybe<PasswordType>;
  /** Preferred language */
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Should change password */
  shouldChangePassword?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateArtefactInput = {
  /** Age ranges */
  ageRanges?: InputMaybe<Array<AgeRange>>;
  /** Child artefact ids */
  childArtefactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Content element ids */
  contentElementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Domains */
  domains?: InputMaybe<Array<Domain>>;
  /** Parent artefact id */
  parentArtefactId?: InputMaybe<Scalars['ID']['input']>;
  /** Title and descriptions */
  titleAndDescriptions?: InputMaybe<Array<SingleLanguageTitleDescriptionDto>>;
};

export type UpdateArtefactRouteInput = {
  /** Artefact ids */
  artefactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Title and descriptions */
  titleAndDescriptions?: InputMaybe<Array<SingleLanguageTitleDescriptionDto>>;
};

export type UpdateContentElementInput = {
  /** Age ranges */
  ageRanges?: InputMaybe<Array<AgeRange>>;
  /** At Home */
  atHome?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** Content id */
  contentId?: InputMaybe<Scalars['String']['input']>;
  /** Content plugin id */
  contentPluginId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** During visit */
  duringVisit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Feedback body */
  feedbackBody?: InputMaybe<Scalars['String']['input']>;
  /** Feedback title */
  feedbackTitle?: InputMaybe<Scalars['String']['input']>;
  /** Language */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Self report type */
  selfReportType?: InputMaybe<SelfReportType>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentPluginInput = {
  /** Application name */
  applicationName?: InputMaybe<Scalars['String']['input']>;
  /** Editor url */
  editorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Resource type */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Title and descriptions */
  titleAndDescriptions?: InputMaybe<Array<SingleLanguageTitleDescriptionDto>>;
  /** Use in chaser */
  useInChaser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use in results */
  useInResults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Viewer url */
  viewerUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentStateInput = {
  /** State */
  state: Scalars['JSON']['input'];
};

export type UpdateScienceOrganisationInput = {
  /** Artefact route ids */
  artefactRouteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Location */
  location?: InputMaybe<LocationDto>;
  /** Logo url */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Member ids */
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notification ids */
  notificationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Title and descriptions */
  titleAndDescriptions?: InputMaybe<Array<SingleLanguageTitleDescriptionDto>>;
  /** Website url */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GetAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAccountQuery = { __typename?: 'Query', getAccountById: { __typename?: 'Account', _id: string, loginName: string, firstName: string, lastName: string, email: string, accountType: AccountType, passwordType: PasswordType, ageRange: AgeRange, gender: Gender, preferredLanguage: string, alternativeLanguages: Array<string>, disabled: boolean, createdAt: any, lastModificationAt: any, creatorId: string, isTestAccount: boolean, creator: { __typename?: 'Account', loginName: string }, lastModifier: { __typename?: 'Account', loginName: string } } };

export type GetProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProfileQuery = { __typename?: 'Query', getAccountById: { __typename?: 'Account', _id: string, loginName: string, firstName: string, lastName: string, email: string, ageRange: AgeRange, gender: Gender, preferredLanguage: string, alternativeLanguages: Array<string>, creatorId: string, isTestAccount: boolean } };

export type GetAccountsQueryVariables = Exact<{
  accountTypes?: InputMaybe<Array<AccountType> | AccountType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAccountsQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', _id: string, loginName: string, email: string, accountType: AccountType, passwordType: PasswordType, disabled: boolean, lastModificationAt: any, creatorId: string }> };

export type GetNrOfAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNrOfAccountsQuery = { __typename?: 'Query', getNrOfAccounts: { __typename?: 'NrOfAccounts', nrOfEnabledAccounts: number, nrOfDisabledAccounts: number, nrOfEnabledAdministrators: number, nrOfDisabledAdministrators: number, nrOfEnabledProjectMembers: number, nrOfDisabledProjectMembers: number, nrOfEnabledParticipants: number, nrOfDisabledParticipants: number } };

export type CreateAccountMutationVariables = Exact<{
  loginName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  accountType: AccountType;
  passwordType: PasswordType;
  password: Scalars['String']['input'];
  ageRange: AgeRange;
  gender: Gender;
  preferredLanguage: Scalars['String']['input'];
  alternativeLanguages: Array<Scalars['String']['input']> | Scalars['String']['input'];
  isTestAccount: Scalars['Boolean']['input'];
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', _id: string } };

export type UpdateAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  loginName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<AccountType>;
  passwordType?: InputMaybe<PasswordType>;
  ageRange?: InputMaybe<AgeRange>;
  gender?: InputMaybe<Gender>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  alternativeLanguages?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isTestAccount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', _id: string, loginName: string, firstName: string, lastName: string, email: string, accountType: AccountType, passwordType: PasswordType, ageRange: AgeRange, gender: Gender, preferredLanguage: string, alternativeLanguages: Array<string>, disabled: boolean, createdAt: any, lastModificationAt: any, creatorId: string, isTestAccount: boolean, creator: { __typename?: 'Account', loginName: string }, lastModifier: { __typename?: 'Account', loginName: string } } };

export type UpdatePasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', _id: string, loginName: string, firstName: string, lastName: string, email: string, accountType: AccountType, passwordType: PasswordType, ageRange: AgeRange, gender: Gender, preferredLanguage: string, alternativeLanguages: Array<string>, disabled: boolean, createdAt: any, lastModificationAt: any, creatorId: string, isTestAccount: boolean, creator: { __typename?: 'Account', loginName: string }, lastModifier: { __typename?: 'Account', loginName: string } } };

export type ChangePasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  confirmPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'Account', _id: string, loginName: string, firstName: string, lastName: string, email: string, accountType: AccountType, passwordType: PasswordType, ageRange: AgeRange, gender: Gender, preferredLanguage: string, alternativeLanguages: Array<string>, disabled: boolean, createdAt: any, lastModificationAt: any, creatorId: string, isTestAccount: boolean, creator: { __typename?: 'Account', loginName: string }, lastModifier: { __typename?: 'Account', loginName: string } } };

export type AcceptLegalTermsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  acceptedLegalTerms?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AcceptLegalTermsMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', _id: string, loginName: string, firstName: string, lastName: string, email: string, accountType: AccountType, passwordType: PasswordType, ageRange: AgeRange, gender: Gender, preferredLanguage: string, alternativeLanguages: Array<string>, disabled: boolean, createdAt: any, lastModificationAt: any, creatorId: string, isTestAccount: boolean, creator: { __typename?: 'Account', loginName: string }, lastModifier: { __typename?: 'Account', loginName: string } } };

export type DisableAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableAccountMutation = { __typename?: 'Mutation', disableAccount: { __typename?: 'Account', _id: string } };

export type EnableAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableAccountMutation = { __typename?: 'Mutation', enableAccount: { __typename?: 'Account', _id: string } };

export type EditAccountDetailsFragment = { __typename?: 'Account', _id: string, loginName: string, firstName: string, lastName: string, email: string, accountType: AccountType, passwordType: PasswordType, ageRange: AgeRange, gender: Gender, preferredLanguage: string, alternativeLanguages: Array<string>, disabled: boolean, createdAt: any, lastModificationAt: any, creatorId: string, isTestAccount: boolean, creator: { __typename?: 'Account', loginName: string }, lastModifier: { __typename?: 'Account', loginName: string } };

export type EditProfileDetailsFragment = { __typename?: 'Account', _id: string, loginName: string, firstName: string, lastName: string, email: string, ageRange: AgeRange, gender: Gender, preferredLanguage: string, alternativeLanguages: Array<string>, creatorId: string, isTestAccount: boolean };

export type GetArtefactRouteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArtefactRouteQuery = { __typename?: 'Query', getArtefactRouteById: { __typename?: 'ArtefactRoute', _id: string, artefactIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, createdAt: any, lastModificationAt: any, trashedAt?: any | null, qrCode?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', title: string, description: string, language: string }>, artefacts: Array<{ __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, domains: Array<Domain>, ageRanges: Array<AgeRange>, trashedAt?: any | null, contentElementIdsWithWarnings?: Array<string> | null, qrCode?: string | null, url: string, childArtefactIds: Array<string>, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } }>, childArtefacts: Array<{ __typename?: 'Artefact', _id: string }> }> } };

export type GetArtefactsAndRoutesForScienceOrganisationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArtefactsAndRoutesForScienceOrganisationQuery = { __typename?: 'Query', getScienceOrganisationById: { __typename?: 'ScienceOrganisation', artefacts: Array<{ __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, trashedAt?: any | null }> }>, artefactRoutes: Array<{ __typename?: 'ArtefactRoute', _id: string, artefactIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, createdAt: any, lastModificationAt: any, trashedAt?: any | null, qrCode?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', title: string, description: string, language: string }>, artefacts: Array<{ __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, domains: Array<Domain>, ageRanges: Array<AgeRange>, trashedAt?: any | null, contentElementIdsWithWarnings?: Array<string> | null, qrCode?: string | null, url: string, childArtefactIds: Array<string>, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } }>, childArtefacts: Array<{ __typename?: 'Artefact', _id: string }> }> }> } };

export type GetRoutesForScienceOrganisationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRoutesForScienceOrganisationQuery = { __typename?: 'Query', getScienceOrganisationById: { __typename?: 'ScienceOrganisation', artefactRoutes: Array<{ __typename?: 'ArtefactRoute', _id: string, artefactIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, createdAt: any, lastModificationAt: any, trashedAt?: any | null, qrCode?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', title: string, description: string, language: string }>, artefacts: Array<{ __typename?: 'Artefact', _id: string, trashedAt?: any | null, disabled: boolean, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', title: string, description: string, language: string }> }> }> } };

export type MoveArtefactRouteToTrashMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MoveArtefactRouteToTrashMutation = { __typename?: 'Mutation', moveArtefactRouteToTrash: { __typename?: 'ArtefactRoute', _id: string, trashedAt?: any | null } };

export type RetrieveArtefactRouteFromTrashMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetrieveArtefactRouteFromTrashMutation = { __typename?: 'Mutation', retrieveArtefactRouteFromTrash: { __typename?: 'ArtefactRoute', _id: string, trashedAt?: any | null } };

export type AddArtefactRouteToScienceOrganisationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto> | SingleLanguageTitleDescriptionDto;
  artefactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddArtefactRouteToScienceOrganisationMutation = { __typename?: 'Mutation', addArtefactRouteToScienceOrganisation: { __typename?: 'ArtefactRouteScienceOrganisation', artefactRoute: { __typename?: 'ArtefactRoute', _id: string, artefactIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, createdAt: any, lastModificationAt: any, trashedAt?: any | null, qrCode?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', title: string, description: string, language: string }>, artefacts: Array<{ __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, domains: Array<Domain>, ageRanges: Array<AgeRange>, trashedAt?: any | null, contentElementIdsWithWarnings?: Array<string> | null, qrCode?: string | null, url: string, childArtefactIds: Array<string>, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } }>, childArtefacts: Array<{ __typename?: 'Artefact', _id: string }> }> } } };

export type UpdateArtefactRouteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto> | SingleLanguageTitleDescriptionDto;
  artefactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateArtefactRouteMutation = { __typename?: 'Mutation', updateArtefactRoute: { __typename?: 'ArtefactRoute', _id: string, artefactIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, createdAt: any, lastModificationAt: any, trashedAt?: any | null, qrCode?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', title: string, description: string, language: string }>, artefacts: Array<{ __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, domains: Array<Domain>, ageRanges: Array<AgeRange>, trashedAt?: any | null, contentElementIdsWithWarnings?: Array<string> | null, qrCode?: string | null, url: string, childArtefactIds: Array<string>, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } }>, childArtefacts: Array<{ __typename?: 'Artefact', _id: string }> }> } };

export type DisableArtefactRouteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableArtefactRouteMutation = { __typename?: 'Mutation', disableArtefactRoute: { __typename?: 'ArtefactRoute', _id: string } };

export type EnableArtefactRouteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableArtefactRouteMutation = { __typename?: 'Mutation', enableArtefactRoute: { __typename?: 'ArtefactRoute', _id: string } };

export type DeleteArtefactRouteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteArtefactRouteMutation = { __typename?: 'Mutation', removeArtefactRoute: { __typename?: 'ArtefactRoute', _id: string } };

export type OrderArtefactRoutesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrderArtefactRoutesMutation = { __typename?: 'Mutation', orderArtefactRoutes: Array<{ __typename?: 'ArtefactRoute', sequenceNumber: number }> };

export type ArtefactRouteOverviewFragment = { __typename?: 'ArtefactRoute', _id: string, artefactIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, createdAt: any, lastModificationAt: any, trashedAt?: any | null, qrCode?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', title: string, description: string, language: string }>, artefacts: Array<{ __typename?: 'Artefact', _id: string, trashedAt?: any | null, disabled: boolean, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', title: string, description: string, language: string }> }> };

export type ArtefactRouteDetailsFragment = { __typename?: 'ArtefactRoute', _id: string, artefactIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, createdAt: any, lastModificationAt: any, trashedAt?: any | null, qrCode?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', title: string, description: string, language: string }>, artefacts: Array<{ __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, domains: Array<Domain>, ageRanges: Array<AgeRange>, trashedAt?: any | null, contentElementIdsWithWarnings?: Array<string> | null, qrCode?: string | null, url: string, childArtefactIds: Array<string>, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } }>, childArtefacts: Array<{ __typename?: 'Artefact', _id: string }> }> };

export type GetArtefactQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArtefactQuery = { __typename?: 'Query', getArtefactById: { __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, domains: Array<Domain>, ageRanges: Array<AgeRange>, trashedAt?: any | null, contentElementIdsWithWarnings?: Array<string> | null, qrCode?: string | null, url: string, childArtefactIds: Array<string>, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } }>, childArtefacts: Array<{ __typename?: 'Artefact', _id: string }> } };

export type GetArtefactOverviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArtefactOverviewQuery = { __typename?: 'Query', getArtefactById: { __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, trashedAt?: any | null }> } };

export type GetArtefactsForScienceOrganisationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArtefactsForScienceOrganisationQuery = { __typename?: 'Query', getScienceOrganisationById: { __typename?: 'ScienceOrganisation', artefacts: Array<{ __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, trashedAt?: any | null }> }> } };

export type GetArtefactsForRoutesQueryVariables = Exact<{
  scienceOrganisationId: Scalars['ID']['input'];
}>;


export type GetArtefactsForRoutesQuery = { __typename?: 'Query', getScienceOrganisationById: { __typename?: 'ScienceOrganisation', artefacts: Array<{ __typename?: 'Artefact', _id: string, disabled: boolean, trashedAt?: any | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> }> } };

export type UpdateArtefactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto> | SingleLanguageTitleDescriptionDto;
  domains?: InputMaybe<Array<Domain> | Domain>;
  contentElementIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type UpdateArtefactMutation = { __typename?: 'Mutation', updateArtefact: { __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, domains: Array<Domain>, ageRanges: Array<AgeRange>, trashedAt?: any | null, contentElementIdsWithWarnings?: Array<string> | null, qrCode?: string | null, url: string, childArtefactIds: Array<string>, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } }>, childArtefacts: Array<{ __typename?: 'Artefact', _id: string }> } };

export type DisableArtefactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableArtefactMutation = { __typename?: 'Mutation', disableArtefact: { __typename?: 'Artefact', _id: string } };

export type EnableArtefactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableArtefactMutation = { __typename?: 'Mutation', enableArtefact: { __typename?: 'Artefact', _id: string } };

export type AddArtefactToScienceOrganisationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto> | SingleLanguageTitleDescriptionDto;
  domains: Array<Domain> | Domain;
  ageRanges: Array<AgeRange> | AgeRange;
}>;


export type AddArtefactToScienceOrganisationMutation = { __typename?: 'Mutation', addArtefactToScienceOrganisation: { __typename?: 'ArtefactScienceOrganisation', artefact: { __typename?: 'Artefact', _id: string } } };

export type RemoveArtefactFromScienceOrganisationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  artefactId: Scalars['ID']['input'];
}>;


export type RemoveArtefactFromScienceOrganisationMutation = { __typename?: 'Mutation', removeArtefactsFromScienceOrganisation: { __typename?: 'ScienceOrganisation', artefacts: Array<{ __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, domains: Array<Domain>, ageRanges: Array<AgeRange>, trashedAt?: any | null, contentElementIdsWithWarnings?: Array<string> | null, qrCode?: string | null, url: string, childArtefactIds: Array<string>, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } }>, childArtefacts: Array<{ __typename?: 'Artefact', _id: string }> }> } };

export type OrderArtefactsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrderArtefactsMutation = { __typename?: 'Mutation', orderArtefacts: Array<{ __typename?: 'Artefact', sequenceNumber: number }> };

export type DuplicateArtefactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  artefactId: Scalars['ID']['input'];
}>;


export type DuplicateArtefactMutation = { __typename?: 'Mutation', duplicateArtefactInScienceOrganisation: { __typename?: 'ArtefactScienceOrganisation', scienceOrganisation: { __typename?: 'ScienceOrganisation', _id: string }, artefact: { __typename?: 'Artefact', _id: string } } };

export type MoveArtefactToTrashMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MoveArtefactToTrashMutation = { __typename?: 'Mutation', moveArtefactToTrash: { __typename?: 'Artefact', _id: string, trashedAt?: any | null } };

export type RetrieveArtefactFromTrashMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetrieveArtefactFromTrashMutation = { __typename?: 'Mutation', retrieveArtefactFromTrash: { __typename?: 'Artefact', _id: string, trashedAt?: any | null } };

export type ArtefactOverviewFragment = { __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, trashedAt?: any | null }> };

export type ArtefactDetailsFragment = { __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, domains: Array<Domain>, ageRanges: Array<AgeRange>, trashedAt?: any | null, contentElementIdsWithWarnings?: Array<string> | null, qrCode?: string | null, url: string, childArtefactIds: Array<string>, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } }>, childArtefacts: Array<{ __typename?: 'Artefact', _id: string }> };

export type GetContentElementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentElementsQuery = { __typename?: 'Query', getAllContentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, url: string, description: string, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> }, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string } }> };

export type GetAllTrashedContentElementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTrashedContentElementsQuery = { __typename?: 'Query', getAllTrashedContentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, url: string, description: string, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> }, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string } }> };

export type GetContentElementOverviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContentElementOverviewQuery = { __typename?: 'Query', getContentElementById: { __typename?: 'ContentElement', _id: string, language: string, title: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, url: string, description: string, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> }, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string } } };

export type GetContentElementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContentElementQuery = { __typename?: 'Query', getContentElementById: { __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } } };

export type GetContentElementsForArtefactQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContentElementsForArtefactQuery = { __typename?: 'Query', getArtefactById: { __typename?: 'Artefact', contentElementIdsWithWarnings?: Array<string> | null, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, url: string, description: string, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> }, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string } }> } };

export type DisableContentElementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableContentElementMutation = { __typename?: 'Mutation', disableContentElement: { __typename?: 'ContentElement', _id: string } };

export type EnableContentElementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableContentElementMutation = { __typename?: 'Mutation', enableContentElement: { __typename?: 'ContentElement', _id: string } };

export type DeleteContentElementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContentElementMutation = { __typename?: 'Mutation', removeContentPlugin: { __typename?: 'ContentPlugin', _id: string } };

export type UpdateContentElementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ageRanges?: InputMaybe<Array<AgeRange> | AgeRange>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  selfReportType?: InputMaybe<SelfReportType>;
  duringVisit?: InputMaybe<Scalars['Boolean']['input']>;
  atHome?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackTitle?: InputMaybe<Scalars['String']['input']>;
  feedbackBody?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateContentElementMutation = { __typename?: 'Mutation', updateContentElement: { __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } } };

export type AddContentElementToArtefactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
  language: Scalars['String']['input'];
  ageRanges: Array<AgeRange> | AgeRange;
  contentPluginId: Scalars['ID']['input'];
  contentId: Scalars['String']['input'];
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  duringVisit?: InputMaybe<Scalars['Boolean']['input']>;
  atHome?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddContentElementToArtefactMutation = { __typename?: 'Mutation', addContentElementToArtefact: { __typename?: 'ContentElementArtefact', contentElement: { __typename?: 'ContentElement', _id: string } } };

export type RemoveContentElementsFromArtefactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contentElementId: Scalars['ID']['input'];
}>;


export type RemoveContentElementsFromArtefactMutation = { __typename?: 'Mutation', removeContentElementsFromArtefact: { __typename?: 'Artefact', _id: string, createdAt: any, lastModificationAt: any, contentElementIds: Array<string>, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, domains: Array<Domain>, ageRanges: Array<AgeRange>, trashedAt?: any | null, contentElementIdsWithWarnings?: Array<string> | null, qrCode?: string | null, url: string, childArtefactIds: Array<string>, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, contentElements: Array<{ __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } }>, childArtefacts: Array<{ __typename?: 'Artefact', _id: string }> } };

export type OrderContentElementsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrderContentElementsMutation = { __typename?: 'Mutation', orderContentElements: Array<{ __typename?: 'ContentElement', sequenceNumber: number }> };

export type DuplicateContentElementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contentElementId: Scalars['ID']['input'];
}>;


export type DuplicateContentElementMutation = { __typename?: 'Mutation', duplicateContentElementInArtefact: { __typename?: 'ContentElementArtefact', artefact: { __typename?: 'Artefact', _id: string }, contentElement: { __typename?: 'ContentElement', _id: string } } };

export type MoveContentElementToTrashMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MoveContentElementToTrashMutation = { __typename?: 'Mutation', moveContentElementToTrash: { __typename?: 'ContentElement', _id: string, trashedAt?: any | null } };

export type RetrieveContentElementFromTrashMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetrieveContentElementFromTrashMutation = { __typename?: 'Mutation', retrieveContentElementFromTrash: { __typename?: 'ContentElement', _id: string, trashedAt?: any | null } };

export type ContentElementDetailsFragment = { __typename?: 'ContentElement', _id: string, language: string, title: string, description: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, configuration?: any | null, url: string, selfReportType?: SelfReportType | null, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string }, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> } };

export type ContentElementOverviewFragment = { __typename?: 'ContentElement', _id: string, language: string, title: string, lastModificationAt: any, createdAt: any, ageRanges: Array<AgeRange>, contentPluginId: string, mayBeDeleted: boolean, disabled: boolean, sequenceNumber: number, trashedAt?: any | null, qrCode?: string | null, contentId: string, url: string, description: string, duringVisit?: boolean | null, atHome?: boolean | null, feedbackTitle?: string | null, feedbackBody?: string | null, contentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> }, lastModifier: { __typename?: 'Account', loginName: string }, creator: { __typename?: 'Account', loginName: string } };

export type GetContentPluginQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContentPluginQuery = { __typename?: 'Query', getContentPluginById: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, resourceType: string, applicationName: string, useInChaser: boolean, useInResults: boolean, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, creator: { __typename?: 'Account', loginName: string }, lastModifier: { __typename?: 'Account', loginName: string } } };

export type GetContentPluginsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentPluginsQuery = { __typename?: 'Query', getAllContentPlugins: Array<{ __typename?: 'ContentPlugin', _id: string, editorUrl: string, useInChaser: boolean, useInResults: boolean, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, sequenceNumber: number, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }> }> };

export type CreateContentPluginMutationVariables = Exact<{
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto> | SingleLanguageTitleDescriptionDto;
  editorUrl: Scalars['String']['input'];
  viewerUrl: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  applicationName: Scalars['String']['input'];
  useInChaser: Scalars['Boolean']['input'];
  useInResults: Scalars['Boolean']['input'];
}>;


export type CreateContentPluginMutation = { __typename?: 'Mutation', createContentPlugin: { __typename?: 'ContentPlugin', _id: string } };

export type UpdateContentPluginMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  titleAndDescriptions?: InputMaybe<Array<SingleLanguageTitleDescriptionDto> | SingleLanguageTitleDescriptionDto>;
  editorUrl?: InputMaybe<Scalars['String']['input']>;
  viewerUrl?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  applicationName?: InputMaybe<Scalars['String']['input']>;
  useInChaser?: InputMaybe<Scalars['Boolean']['input']>;
  useInResults?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateContentPluginMutation = { __typename?: 'Mutation', updateContentPlugin: { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, resourceType: string, applicationName: string, useInChaser: boolean, useInResults: boolean, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, creator: { __typename?: 'Account', loginName: string }, lastModifier: { __typename?: 'Account', loginName: string } } };

export type DisableContentPluginMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableContentPluginMutation = { __typename?: 'Mutation', disableContentPlugin: { __typename?: 'ContentPlugin', _id: string } };

export type EnableContentPluginMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableContentPluginMutation = { __typename?: 'Mutation', enableContentPlugin: { __typename?: 'ContentPlugin', _id: string } };

export type DeleteContentPluginMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContentPluginMutation = { __typename?: 'Mutation', removeContentPlugin: { __typename?: 'ContentPlugin', _id: string } };

export type OrderContentPluginsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrderContentPluginsMutation = { __typename?: 'Mutation', orderContentPlugins: Array<{ __typename?: 'ContentPlugin', sequenceNumber: number }> };

export type EditContentPluginDetailsFragment = { __typename?: 'ContentPlugin', _id: string, editorUrl: string, viewerUrl: string, resourceType: string, applicationName: string, useInChaser: boolean, useInResults: boolean, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, creator: { __typename?: 'Account', loginName: string }, lastModifier: { __typename?: 'Account', loginName: string } };

export type GetIlsStructureJsonQueryVariables = Exact<{
  scienceOrganisationId: Scalars['ID']['input'];
}>;


export type GetIlsStructureJsonQuery = { __typename?: 'Query', getIlsStructureJson: { __typename?: 'IlsStructureJson', ilsStructure: any } };

export type QueryResourcesJsonQueryVariables = Exact<{
  scienceOrganisationId: Scalars['ID']['input'];
  actorId?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  orderByModificationDate?: InputMaybe<Scalars['Boolean']['input']>;
  returnMetadataOnly?: InputMaybe<Scalars['Boolean']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueryResourcesJsonQuery = { __typename?: 'Query', queryResourcesJson: { __typename?: 'ResourceQueryResultJson', resourceQueryResults: any } };

export type ReadResourceJsonQueryVariables = Exact<{
  scienceOrganisationId: Scalars['ID']['input'];
  resourceId: Scalars['ID']['input'];
}>;


export type ReadResourceJsonQuery = { __typename?: 'Query', readResourceJson: { __typename?: 'ResourceReadResultJson', resourceReadResults: any } };

export type UpdateResourceJsonQueryVariables = Exact<{
  resource: ResourceJsonInput;
}>;


export type UpdateResourceJsonQuery = { __typename?: 'Query', updateResourceJson: { __typename?: 'ResourceUpdateResultJson', resourceUpdateResults: any } };

export type RetrieveLogActionsJsonQueryVariables = Exact<{
  scienceOrganisationId: Scalars['ID']['input'];
  logActionQueryJSONInput: LogActionQueryJsonInput;
  logActionProjectionJSONInput: LogActionProjectionJsonInput;
}>;


export type RetrieveLogActionsJsonQuery = { __typename?: 'Query', retrieveLogActionsJson: { __typename?: 'LogAccessorQueryResultJson', logAccessorQueryResults: any } };

export type RetrieveActorsQueryVariables = Exact<{ [key: string]: never; }>;


export type RetrieveActorsQuery = { __typename?: 'Query', retrieveActors: Array<{ __typename?: 'Actor', id: string, displayName: string, objectType: string }> };

export type GetUsersWithNotificationsEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersWithNotificationsEnabledQuery = { __typename?: 'Query', getUsersWithNotificationsEnabled: Array<{ __typename?: 'Account', _id: string, loginName: string, deviceIds: Array<string> }> };

export type SendGenericActivityReminderToEveryoneMutationVariables = Exact<{ [key: string]: never; }>;


export type SendGenericActivityReminderToEveryoneMutation = { __typename?: 'Mutation', sendGenericActivityReminderToEveryone: { __typename?: 'Notification', _id: string, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> } };

export type SendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDaysMutationVariables = Exact<{ [key: string]: never; }>;


export type SendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDaysMutation = { __typename?: 'Mutation', sendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDays: { __typename?: 'Notification', _id: string, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> } };

export type SendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDaysMutationVariables = Exact<{ [key: string]: never; }>;


export type SendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDaysMutation = { __typename?: 'Mutation', sendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDays: { __typename?: 'Notification', _id: string, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> } };

export type SendStreakReminderToEveryoneMutationVariables = Exact<{ [key: string]: never; }>;


export type SendStreakReminderToEveryoneMutation = { __typename?: 'Mutation', sendStreakReminderToEveryone: { __typename?: 'Notification', _id: string, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> } };

export type SendStreakAboutToExpireToEveryoneMutationVariables = Exact<{ [key: string]: never; }>;


export type SendStreakAboutToExpireToEveryoneMutation = { __typename?: 'Mutation', sendStreakAboutToExpireToEveryone: { __typename?: 'Notification', _id: string, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> } };

export type SendNotificationMutationVariables = Exact<{
  title: Scalars['String']['input'];
  body: Scalars['String']['input'];
  scienceOrganisationId?: InputMaybe<Scalars['ID']['input']>;
  artefactId?: InputMaybe<Scalars['ID']['input']>;
  contentElementId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SendNotificationMutation = { __typename?: 'Mutation', sendNotification: { __typename?: 'Notification', _id: string, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> } };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename?: 'Query', getNotifications: Array<{ __typename?: 'Notification', _id: string, createdAt: any, lastModificationAt: any, sentToAccountIds: Array<string>, payload: { __typename?: 'NotificationPayload', title: string, body: string, icon: string, data?: any | null }, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> }> };

export type GetNotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetNotificationQuery = { __typename?: 'Query', getNotificationById: { __typename?: 'Notification', _id: string, createdAt: any, lastModificationAt: any, sentToAccountIds: Array<string>, payload: { __typename?: 'NotificationPayload', title: string, body: string, icon: string, data?: any | null }, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> } };

export type GetNotificationsForScienceOrganisationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetNotificationsForScienceOrganisationQuery = { __typename?: 'Query', getScienceOrganisationById: { __typename?: 'ScienceOrganisation', notifications: Array<{ __typename?: 'Notification', _id: string, createdAt: any, lastModificationAt: any, sentToAccountIds: Array<string>, payload: { __typename?: 'NotificationPayload', title: string, body: string, icon: string, data?: any | null }, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> }> } };

export type NotificationDetailsFragment = { __typename?: 'Notification', _id: string, createdAt: any, lastModificationAt: any, sentToAccountIds: Array<string>, payload: { __typename?: 'NotificationPayload', title: string, body: string, icon: string, data?: any | null }, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> };

export type NotificationOverviewFragment = { __typename?: 'Notification', _id: string, createdAt: any, lastModificationAt: any, sentToAccountIds: Array<string>, payload: { __typename?: 'NotificationPayload', title: string, body: string, icon: string, data?: any | null }, accountsWhoReceivedNotifications: Array<{ __typename?: 'Account', _id: string, loginName: string }> };

export type FindQrCodeDescriptionQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type FindQrCodeDescriptionQuery = { __typename?: 'Query', findQrCodeDescription: { __typename?: 'QrCodeDescription', targetType: QrCodeTargetType, artefactId?: string | null, contentElementId?: string | null, scienceOrganisationId?: string | null, artefactRouteId?: string | null, scienceOrganisation: { __typename?: 'ScienceOrganisation', _id: string, logoUrl?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string }> }, artefact?: { __typename?: 'Artefact', _id: string, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string }> } | null, contentElement?: { __typename?: 'ContentElement', _id: string, title: string } | null, artefactRoute?: { __typename?: 'ArtefactRoute', _id: string, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string }> } | null } };

export type CreateQrCodeMutationVariables = Exact<{
  targetId: Scalars['ID']['input'];
  targetType: QrCodeTargetType;
}>;


export type CreateQrCodeMutation = { __typename?: 'Mutation', createQrCode: { __typename?: 'QrCode', targetType: QrCodeTargetType, targetId: string, code: string } };

export type GetScienceOrganisationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScienceOrganisationsQuery = { __typename?: 'Query', getAllScienceOrganisations: Array<{ __typename?: 'ScienceOrganisation', _id: string, url: string, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, artefactIds: Array<string>, artefactRouteIds: Array<string>, sequenceNumber: number, trashedAt?: any | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, artefacts: Array<{ __typename?: 'Artefact', trashedAt?: any | null }> }> };

export type GetAllTrashedScienceOrganisationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTrashedScienceOrganisationsQuery = { __typename?: 'Query', getAllTrashedScienceOrganisations: Array<{ __typename?: 'ScienceOrganisation', _id: string, url: string, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, artefactIds: Array<string>, artefactRouteIds: Array<string>, sequenceNumber: number, trashedAt?: any | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, artefacts: Array<{ __typename?: 'Artefact', trashedAt?: any | null }> }> };

export type GetScienceOrganisationsWithMembersArtefactsContentElementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScienceOrganisationsWithMembersArtefactsContentElementsQuery = { __typename?: 'Query', getAllScienceOrganisations: Array<{ __typename?: 'ScienceOrganisation', _id: string, memberIds: Array<string>, artefactIds: Array<string>, artefactRouteIds: Array<string>, artefacts: Array<{ __typename?: 'Artefact', contentElementIds: Array<string> }> }> };

export type GetTrashedScienceOrganisationsWithMembersArtefactsContentElementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrashedScienceOrganisationsWithMembersArtefactsContentElementsQuery = { __typename?: 'Query', getAllTrashedScienceOrganisations: Array<{ __typename?: 'ScienceOrganisation', _id: string, memberIds: Array<string>, artefactIds: Array<string>, artefactRouteIds: Array<string>, artefacts: Array<{ __typename?: 'Artefact', contentElementIds: Array<string> }> }> };

export type GetScienceOrganisationOverviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScienceOrganisationOverviewQuery = { __typename?: 'Query', getScienceOrganisationById: { __typename?: 'ScienceOrganisation', _id: string, url: string, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, artefactIds: Array<string>, artefactRouteIds: Array<string>, sequenceNumber: number, trashedAt?: any | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, artefacts: Array<{ __typename?: 'Artefact', trashedAt?: any | null }> } };

export type GetScienceOrganisationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScienceOrganisationQuery = { __typename?: 'Query', getScienceOrganisationById: { __typename?: 'ScienceOrganisation', _id: string, url: string, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, websiteUrl?: string | null, logoUrl?: string | null, memberIds: Array<string>, trashedAt?: any | null, qrCode?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, members: Array<{ __typename?: 'Account', _id: string, loginName: string }>, location: { __typename?: 'Location', locationType: LocationType, gpsLocation?: { __typename?: 'GpsLocation', latitude: string, longitude: string } | null, address?: { __typename?: 'Address', city: string, country: string, houseNumber: string, state?: string | null, zipCode: string, street: string } | null } } };

export type GetAccountsForScienceOrganisationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAccountsForScienceOrganisationQuery = { __typename?: 'Query', getAccountsForScienceOrganisation: string };

export type GetMemberAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMemberAccountsQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', _id: string, loginName: string, accountType: AccountType, disabled: boolean }> };

export type DeleteScienceOrganisationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteScienceOrganisationMutation = { __typename?: 'Mutation', removeScienceOrganisation: { __typename?: 'ScienceOrganisation', _id: string } };

export type CreateScienceOrganisationMutationVariables = Exact<{
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto> | SingleLanguageTitleDescriptionDto;
  memberIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  location: LocationDto;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateScienceOrganisationMutation = { __typename?: 'Mutation', createScienceOrganisation: { __typename?: 'ScienceOrganisation', _id: string } };

export type UpdateScienceOrganisationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto> | SingleLanguageTitleDescriptionDto;
  memberIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  location: LocationDto;
  artefactRouteIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type UpdateScienceOrganisationMutation = { __typename?: 'Mutation', updateScienceOrganisation: { __typename?: 'ScienceOrganisation', _id: string, url: string, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, websiteUrl?: string | null, logoUrl?: string | null, memberIds: Array<string>, trashedAt?: any | null, qrCode?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, members: Array<{ __typename?: 'Account', _id: string, loginName: string }>, location: { __typename?: 'Location', locationType: LocationType, gpsLocation?: { __typename?: 'GpsLocation', latitude: string, longitude: string } | null, address?: { __typename?: 'Address', city: string, country: string, houseNumber: string, state?: string | null, zipCode: string, street: string } | null } } };

export type DisableScienceOrganisationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableScienceOrganisationMutation = { __typename?: 'Mutation', disableScienceOrganisation: { __typename?: 'ScienceOrganisation', _id: string } };

export type EnableScienceOrganisationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableScienceOrganisationMutation = { __typename?: 'Mutation', enableScienceOrganisation: { __typename?: 'ScienceOrganisation', _id: string } };

export type OrderScienceOrganisationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrderScienceOrganisationsMutation = { __typename?: 'Mutation', orderScienceOrganisations: Array<{ __typename?: 'ScienceOrganisation', sequenceNumber: number }> };

export type MoveScienceOrganisationToTrashMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MoveScienceOrganisationToTrashMutation = { __typename?: 'Mutation', moveScienceOrganisationToTrash: { __typename?: 'ScienceOrganisation', _id: string } };

export type RetrieveScienceOrganisationFromTrashMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetrieveScienceOrganisationFromTrashMutation = { __typename?: 'Mutation', retrieveScienceOrganisationFromTrash: { __typename?: 'ScienceOrganisation', _id: string } };

export type ScienceOrganisationDetailsFragment = { __typename?: 'ScienceOrganisation', _id: string, url: string, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, websiteUrl?: string | null, logoUrl?: string | null, memberIds: Array<string>, trashedAt?: any | null, qrCode?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, members: Array<{ __typename?: 'Account', _id: string, loginName: string }>, location: { __typename?: 'Location', locationType: LocationType, gpsLocation?: { __typename?: 'GpsLocation', latitude: string, longitude: string } | null, address?: { __typename?: 'Address', city: string, country: string, houseNumber: string, state?: string | null, zipCode: string, street: string } | null } };

export type ScienceOrganisationOverviewFragment = { __typename?: 'ScienceOrganisation', _id: string, url: string, createdAt: any, lastModificationAt: any, disabled: boolean, mayBeDeleted: boolean, artefactIds: Array<string>, artefactRouteIds: Array<string>, sequenceNumber: number, trashedAt?: any | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string, description: string }>, artefacts: Array<{ __typename?: 'Artefact', trashedAt?: any | null }> };

export type ScienceOrganisationDetailsWithOnlyIdsFragment = { __typename?: 'ScienceOrganisation', _id: string, memberIds: Array<string>, artefactIds: Array<string>, artefactRouteIds: Array<string>, artefacts: Array<{ __typename?: 'Artefact', contentElementIds: Array<string> }> };

export type GetAllSelfReportsExcelWithAccountInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSelfReportsExcelWithAccountInfoQuery = { __typename?: 'Query', getAllSelfReportsExcelWithAccountInfo: string };

export type GetServerStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServerStatusQuery = { __typename?: 'Query', getServerStatus: { __typename?: 'ServerStatus', totalDiskSpace: number, freeDiskSpace: number, nrOfCpus: number, totalMemory: number, freeMemory: number, osType: string, osVersion: string, osRelease: string, uptime: number, averageLoad: Array<number> } };

export type GetStorageStatusOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStorageStatusOverviewQuery = { __typename?: 'Query', getStorageStatusOverview: { __typename?: 'StorageStatusOverview', collectionOverviews: Array<{ __typename?: 'CollectionOverview', name: string, nrOfObjects: number, nrOfEnabledObjects: number, nrOfDisabledObjects: number, nrOfNotTrashedObjects: number, nrOfTrashedObjects: number, nrOfUsableObjects: number, bytes?: number | null, kilobytes?: number | null }>, mongoDbVersion: { __typename?: 'MongoDbVersion', version: string, openSslRunningVersion: string, openSslCompiledVersion: string, ok: number } } };

export type CollectionOverviewDetailsFragment = { __typename?: 'CollectionOverview', name: string, nrOfObjects: number, nrOfEnabledObjects: number, nrOfDisabledObjects: number, nrOfNotTrashedObjects: number, nrOfTrashedObjects: number, nrOfUsableObjects: number, bytes?: number | null, kilobytes?: number | null };

export type GetMigrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMigrationsQuery = { __typename?: 'Query', getMigrations: Array<{ __typename?: 'ChangeLog', _id: string, fileName: string, appliedAt: any }> };

export type GetCollectionIndicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionIndicesQuery = { __typename?: 'Query', getCollectionIndices: Array<{ __typename?: 'CollectionIndices', name: string, indices: Array<{ __typename?: 'IndexDefinition2', fields: Array<{ __typename?: 'KeyValue', key: string, value: string }>, options: Array<{ __typename?: 'KeyValue', key: string, value: string }> }> }> };

export type AddLogActionMutationVariables = Exact<{
  sessionSequenceNumber: Scalars['Int']['input'];
  actorId: Scalars['ID']['input'];
  clientDate: Scalars['Timestamp']['input'];
  app: ActionApp;
  verb: ActionVerb;
  targetType: TargetTypes;
  targetId: Scalars['ID']['input'];
  description: Scalars['JSON']['input'];
}>;


export type AddLogActionMutation = { __typename?: 'Mutation', addLogAction: { __typename?: 'LogAction', _id: string } };

export type GetLogActionSummariesQueryVariables = Exact<{
  actionApps?: InputMaybe<Array<ActionApp> | ActionApp>;
  actionVerbs?: InputMaybe<Array<ActionVerb> | ActionVerb>;
  targetTypes?: InputMaybe<Array<TargetTypes> | TargetTypes>;
}>;


export type GetLogActionSummariesQuery = { __typename?: 'Query', getLogActionSummaries: { __typename?: 'LogActionSummaries', totalNr: number, logActionSummaries: Array<{ __typename?: 'LogActionSummary', _id: string, serverDate: any, clientDate: any, loginName: string, sessionSequenceNumber: number, verb: ActionVerb, targetType: TargetTypes, app: ActionApp }>, nrsPerActionApp: Array<{ __typename?: 'KeyCount', key: string, count: number }>, nrsPerActionVerb: Array<{ __typename?: 'KeyCount', key: string, count: number }>, nrsPerTargetType: Array<{ __typename?: 'KeyCount', key: string, count: number }> } };

export type GetLogActionKeyCountsQueryVariables = Exact<{
  actionApps?: InputMaybe<Array<ActionApp> | ActionApp>;
  actionVerbs?: InputMaybe<Array<ActionVerb> | ActionVerb>;
  targetTypes?: InputMaybe<Array<TargetTypes> | TargetTypes>;
  scienceOrganisationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
}>;


export type GetLogActionKeyCountsQuery = { __typename?: 'Query', getLogActionKeyCounts: { __typename?: 'LogActionKeyCounts', totalNr: number, nrsPerActionApp: Array<{ __typename?: 'KeyCount', key: string, count: number }>, nrsPerActionVerb: Array<{ __typename?: 'KeyCount', key: string, count: number }>, nrsPerTargetType: Array<{ __typename?: 'KeyCount', key: string, count: number }>, nrsPerScienceOrganisationId: Array<{ __typename?: 'KeyCount', key: string, count: number }> } };

export type GetLogActionsByQueryQueryVariables = Exact<{
  actionApps?: InputMaybe<Array<ActionApp> | ActionApp>;
  actionVerbs?: InputMaybe<Array<ActionVerb> | ActionVerb>;
  targetTypes?: InputMaybe<Array<TargetTypes> | TargetTypes>;
  pageSize: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  scienceOrganisationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  lastLogActionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLogActionsByQueryQuery = { __typename?: 'Query', getLogActionsByQuery: Array<{ __typename?: 'LogAction', _id: string, clientDate: any, serverDate: any, actorId: string, sessionSequenceNumber: number, verb: ActionVerb, app: ActionApp, targetType: TargetTypes, targetId: string, description?: any | null, actor: { __typename?: 'Account', _id: string, loginName: string, accountType: AccountType } }> };

export type GetLogActionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLogActionQuery = { __typename?: 'Query', getLogActionById: { __typename?: 'LogAction', _id: string, clientDate: any, serverDate: any, actorId: string, sessionSequenceNumber: number, verb: ActionVerb, targetType: TargetTypes, targetId: string, description?: any | null, actor: { __typename?: 'Account', _id: string, loginName: string, accountType: AccountType } } };

export type GetNrOfLogActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNrOfLogActionsQuery = { __typename?: 'Query', getNrOfLogActions: { __typename?: 'NrOfLogActions', nrOfServerLogActions: number, nrOfDigitalToolboxManagerLogActions: number, nrOfChaserLogActions: number } };

export const EditAccountDetailsFragmentDoc = gql`
    fragment editAccountDetails on Account {
  _id
  loginName
  firstName
  lastName
  email
  accountType
  passwordType
  ageRange
  gender
  preferredLanguage
  alternativeLanguages
  disabled
  createdAt
  lastModificationAt
  creator {
    loginName
  }
  lastModifier {
    loginName
  }
  creatorId
  isTestAccount
}
    `;
export const EditProfileDetailsFragmentDoc = gql`
    fragment editProfileDetails on Account {
  _id
  loginName
  firstName
  lastName
  email
  ageRange
  gender
  preferredLanguage
  alternativeLanguages
  creatorId
  isTestAccount
}
    `;
export const ArtefactRouteOverviewFragmentDoc = gql`
    fragment artefactRouteOverview on ArtefactRoute {
  _id
  titleAndDescriptions {
    title
    description
    language
  }
  artefactIds
  artefacts {
    _id
    titleAndDescriptions {
      title
      description
      language
    }
    trashedAt
    disabled
  }
  mayBeDeleted
  disabled
  sequenceNumber
  createdAt
  lastModificationAt
  trashedAt
  qrCode
}
    `;
export const ContentElementDetailsFragmentDoc = gql`
    fragment contentElementDetails on ContentElement {
  _id
  language
  title
  description
  lastModifier {
    loginName
  }
  creator {
    loginName
  }
  lastModificationAt
  createdAt
  ageRanges
  contentPluginId
  contentPlugin {
    _id
    titleAndDescriptions {
      language
      title
      description
    }
    editorUrl
    viewerUrl
    sequenceNumber
  }
  mayBeDeleted
  disabled
  sequenceNumber
  trashedAt
  qrCode
  contentId
  configuration
  url
  selfReportType
  duringVisit
  atHome
  feedbackTitle
  feedbackBody
}
    `;
export const ArtefactDetailsFragmentDoc = gql`
    fragment artefactDetails on Artefact {
  _id
  titleAndDescriptions {
    language
    title
    description
  }
  createdAt
  lastModificationAt
  contentElementIds
  mayBeDeleted
  disabled
  sequenceNumber
  contentElements {
    ...contentElementDetails
  }
  domains
  ageRanges
  trashedAt
  contentElementIdsWithWarnings
  qrCode
  url
  childArtefactIds
  childArtefacts {
    _id
  }
}
    ${ContentElementDetailsFragmentDoc}`;
export const ArtefactRouteDetailsFragmentDoc = gql`
    fragment artefactRouteDetails on ArtefactRoute {
  _id
  titleAndDescriptions {
    title
    description
    language
  }
  artefactIds
  artefacts {
    ...artefactDetails
  }
  mayBeDeleted
  disabled
  sequenceNumber
  createdAt
  lastModificationAt
  trashedAt
  qrCode
}
    ${ArtefactDetailsFragmentDoc}`;
export const ArtefactOverviewFragmentDoc = gql`
    fragment artefactOverview on Artefact {
  _id
  titleAndDescriptions {
    language
    title
    description
  }
  createdAt
  lastModificationAt
  contentElementIds
  mayBeDeleted
  disabled
  sequenceNumber
  contentElements {
    _id
    trashedAt
  }
  trashedAt
}
    `;
export const ContentElementOverviewFragmentDoc = gql`
    fragment contentElementOverview on ContentElement {
  _id
  language
  title
  lastModificationAt
  createdAt
  ageRanges
  contentPluginId
  contentPlugin {
    _id
    titleAndDescriptions {
      language
      title
      description
    }
  }
  mayBeDeleted
  disabled
  sequenceNumber
  trashedAt
  qrCode
  contentId
  url
  description
  lastModifier {
    loginName
  }
  creator {
    loginName
  }
  contentPlugin {
    _id
    titleAndDescriptions {
      language
      title
      description
    }
    editorUrl
    viewerUrl
    sequenceNumber
  }
  duringVisit
  atHome
  feedbackTitle
  feedbackBody
}
    `;
export const EditContentPluginDetailsFragmentDoc = gql`
    fragment editContentPluginDetails on ContentPlugin {
  _id
  titleAndDescriptions {
    language
    title
    description
  }
  editorUrl
  viewerUrl
  resourceType
  applicationName
  useInChaser
  useInResults
  createdAt
  lastModificationAt
  creator {
    loginName
  }
  lastModifier {
    loginName
  }
  disabled
  mayBeDeleted
}
    `;
export const NotificationDetailsFragmentDoc = gql`
    fragment notificationDetails on Notification {
  _id
  payload {
    title
    body
    icon
    data
  }
  createdAt
  lastModificationAt
  sentToAccountIds
  accountsWhoReceivedNotifications {
    _id
    loginName
  }
}
    `;
export const NotificationOverviewFragmentDoc = gql`
    fragment notificationOverview on Notification {
  _id
  payload {
    title
    body
    icon
    data
  }
  createdAt
  lastModificationAt
  sentToAccountIds
  accountsWhoReceivedNotifications {
    _id
    loginName
  }
}
    `;
export const ScienceOrganisationDetailsFragmentDoc = gql`
    fragment scienceOrganisationDetails on ScienceOrganisation {
  _id
  url
  titleAndDescriptions {
    language
    title
    description
  }
  members {
    _id
    loginName
  }
  location {
    gpsLocation {
      latitude
      longitude
    }
    locationType
    address {
      city
      country
      houseNumber
      state
      zipCode
      street
    }
  }
  createdAt
  lastModificationAt
  disabled
  mayBeDeleted
  websiteUrl
  logoUrl
  memberIds
  trashedAt
  qrCode
}
    `;
export const ScienceOrganisationOverviewFragmentDoc = gql`
    fragment scienceOrganisationOverview on ScienceOrganisation {
  _id
  url
  titleAndDescriptions {
    language
    title
    description
  }
  createdAt
  lastModificationAt
  disabled
  mayBeDeleted
  artefactIds
  artefacts {
    trashedAt
  }
  artefactRouteIds
  sequenceNumber
  trashedAt
}
    `;
export const ScienceOrganisationDetailsWithOnlyIdsFragmentDoc = gql`
    fragment scienceOrganisationDetailsWithOnlyIds on ScienceOrganisation {
  _id
  memberIds
  artefactIds
  artefacts {
    contentElementIds
  }
  artefactRouteIds
}
    `;
export const CollectionOverviewDetailsFragmentDoc = gql`
    fragment collectionOverviewDetails on CollectionOverview {
  name
  nrOfObjects
  nrOfEnabledObjects
  nrOfDisabledObjects
  nrOfNotTrashedObjects
  nrOfTrashedObjects
  nrOfUsableObjects
  bytes
  kilobytes
}
    `;
export const GetAccountDocument = gql`
    query getAccount($id: ID!) {
  getAccountById(id: $id) {
    ...editAccountDetails
  }
}
    ${EditAccountDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccountGQL extends Apollo.Query<GetAccountQuery, GetAccountQueryVariables> {
    document = GetAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileDocument = gql`
    query getProfile($id: ID!) {
  getAccountById(id: $id) {
    ...editProfileDetails
  }
}
    ${EditProfileDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileGQL extends Apollo.Query<GetProfileQuery, GetProfileQueryVariables> {
    document = GetProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAccountsDocument = gql`
    query getAccounts($accountTypes: [AccountType!], $disabled: Boolean) {
  getAccounts(accountQuery: {accountTypes: $accountTypes, disabled: $disabled}) {
    _id
    loginName
    email
    accountType
    passwordType
    disabled
    lastModificationAt
    creatorId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccountsGQL extends Apollo.Query<GetAccountsQuery, GetAccountsQueryVariables> {
    document = GetAccountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNrOfAccountsDocument = gql`
    query getNrOfAccounts {
  getNrOfAccounts {
    nrOfEnabledAccounts
    nrOfDisabledAccounts
    nrOfEnabledAdministrators
    nrOfDisabledAdministrators
    nrOfEnabledProjectMembers
    nrOfDisabledProjectMembers
    nrOfEnabledParticipants
    nrOfDisabledParticipants
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNrOfAccountsGQL extends Apollo.Query<GetNrOfAccountsQuery, GetNrOfAccountsQueryVariables> {
    document = GetNrOfAccountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAccountDocument = gql`
    mutation createAccount($loginName: String!, $firstName: String!, $lastName: String!, $email: String!, $accountType: AccountType!, $passwordType: PasswordType!, $password: String!, $ageRange: AgeRange!, $gender: Gender!, $preferredLanguage: String!, $alternativeLanguages: [String!]!, $isTestAccount: Boolean!) {
  createAccount(
    createAccountInput: {loginName: $loginName, firstName: $firstName, lastName: $lastName, email: $email, accountType: $accountType, passwordType: $passwordType, password: $password, ageRange: $ageRange, gender: $gender, preferredLanguage: $preferredLanguage, alternativeLanguages: $alternativeLanguages, isTestAccount: $isTestAccount}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAccountGQL extends Apollo.Mutation<CreateAccountMutation, CreateAccountMutationVariables> {
    document = CreateAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAccountDocument = gql`
    mutation updateAccount($id: ID!, $loginName: String, $firstName: String, $lastName: String, $email: String, $accountType: AccountType, $passwordType: PasswordType, $ageRange: AgeRange, $gender: Gender, $preferredLanguage: String, $alternativeLanguages: [String!], $isTestAccount: Boolean) {
  updateAccount(
    id: $id
    updateAccountInput: {loginName: $loginName, firstName: $firstName, lastName: $lastName, email: $email, accountType: $accountType, passwordType: $passwordType, ageRange: $ageRange, gender: $gender, preferredLanguage: $preferredLanguage, alternativeLanguages: $alternativeLanguages, isTestAccount: $isTestAccount}
  ) {
    ...editAccountDetails
  }
}
    ${EditAccountDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAccountGQL extends Apollo.Mutation<UpdateAccountMutation, UpdateAccountMutationVariables> {
    document = UpdateAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePasswordDocument = gql`
    mutation updatePassword($id: ID!, $password: String) {
  updateAccount(id: $id, updateAccountInput: {password: $password}) {
    ...editAccountDetails
  }
}
    ${EditAccountDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePasswordGQL extends Apollo.Mutation<UpdatePasswordMutation, UpdatePasswordMutationVariables> {
    document = UpdatePasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePasswordDocument = gql`
    mutation changePassword($id: ID!, $oldPassword: String!, $newPassword: String!, $confirmPassword: String!) {
  changePassword(
    id: $id
    changePasswordInput: {oldPassword: $oldPassword, newPassword: $newPassword, confirmPassword: $confirmPassword}
  ) {
    ...editAccountDetails
  }
}
    ${EditAccountDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePasswordGQL extends Apollo.Mutation<ChangePasswordMutation, ChangePasswordMutationVariables> {
    document = ChangePasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptLegalTermsDocument = gql`
    mutation acceptLegalTerms($id: ID!, $acceptedLegalTerms: Boolean) {
  updateAccount(
    id: $id
    updateAccountInput: {acceptedLegalTerms: $acceptedLegalTerms}
  ) {
    ...editAccountDetails
  }
}
    ${EditAccountDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptLegalTermsGQL extends Apollo.Mutation<AcceptLegalTermsMutation, AcceptLegalTermsMutationVariables> {
    document = AcceptLegalTermsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableAccountDocument = gql`
    mutation disableAccount($id: ID!) {
  disableAccount(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableAccountGQL extends Apollo.Mutation<DisableAccountMutation, DisableAccountMutationVariables> {
    document = DisableAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableAccountDocument = gql`
    mutation enableAccount($id: ID!) {
  enableAccount(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableAccountGQL extends Apollo.Mutation<EnableAccountMutation, EnableAccountMutationVariables> {
    document = EnableAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetArtefactRouteDocument = gql`
    query getArtefactRoute($id: ID!) {
  getArtefactRouteById(id: $id) {
    ...artefactRouteDetails
  }
}
    ${ArtefactRouteDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetArtefactRouteGQL extends Apollo.Query<GetArtefactRouteQuery, GetArtefactRouteQueryVariables> {
    document = GetArtefactRouteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetArtefactsAndRoutesForScienceOrganisationDocument = gql`
    query getArtefactsAndRoutesForScienceOrganisation($id: ID!) {
  getScienceOrganisationById(id: $id) {
    artefacts {
      ...artefactOverview
    }
    artefactRoutes {
      ...artefactRouteDetails
    }
  }
}
    ${ArtefactOverviewFragmentDoc}
${ArtefactRouteDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetArtefactsAndRoutesForScienceOrganisationGQL extends Apollo.Query<GetArtefactsAndRoutesForScienceOrganisationQuery, GetArtefactsAndRoutesForScienceOrganisationQueryVariables> {
    document = GetArtefactsAndRoutesForScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRoutesForScienceOrganisationDocument = gql`
    query getRoutesForScienceOrganisation($id: ID!) {
  getScienceOrganisationById(id: $id) {
    artefactRoutes {
      ...artefactRouteOverview
    }
  }
}
    ${ArtefactRouteOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoutesForScienceOrganisationGQL extends Apollo.Query<GetRoutesForScienceOrganisationQuery, GetRoutesForScienceOrganisationQueryVariables> {
    document = GetRoutesForScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveArtefactRouteToTrashDocument = gql`
    mutation moveArtefactRouteToTrash($id: ID!) {
  moveArtefactRouteToTrash(id: $id) {
    _id
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveArtefactRouteToTrashGQL extends Apollo.Mutation<MoveArtefactRouteToTrashMutation, MoveArtefactRouteToTrashMutationVariables> {
    document = MoveArtefactRouteToTrashDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RetrieveArtefactRouteFromTrashDocument = gql`
    mutation retrieveArtefactRouteFromTrash($id: ID!) {
  retrieveArtefactRouteFromTrash(id: $id) {
    _id
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RetrieveArtefactRouteFromTrashGQL extends Apollo.Mutation<RetrieveArtefactRouteFromTrashMutation, RetrieveArtefactRouteFromTrashMutationVariables> {
    document = RetrieveArtefactRouteFromTrashDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddArtefactRouteToScienceOrganisationDocument = gql`
    mutation addArtefactRouteToScienceOrganisation($id: ID!, $titleAndDescriptions: [SingleLanguageTitleDescriptionDTO!]!, $artefactIds: [ID!]!) {
  addArtefactRouteToScienceOrganisation(
    id: $id
    createArtefactRouteInput: {titleAndDescriptions: $titleAndDescriptions, artefactIds: $artefactIds}
  ) {
    artefactRoute {
      ...artefactRouteDetails
    }
  }
}
    ${ArtefactRouteDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddArtefactRouteToScienceOrganisationGQL extends Apollo.Mutation<AddArtefactRouteToScienceOrganisationMutation, AddArtefactRouteToScienceOrganisationMutationVariables> {
    document = AddArtefactRouteToScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateArtefactRouteDocument = gql`
    mutation updateArtefactRoute($id: ID!, $titleAndDescriptions: [SingleLanguageTitleDescriptionDTO!]!, $artefactIds: [ID!]!) {
  updateArtefactRoute(
    id: $id
    updateArtefactRouteInput: {titleAndDescriptions: $titleAndDescriptions, artefactIds: $artefactIds}
  ) {
    ...artefactRouteDetails
  }
}
    ${ArtefactRouteDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateArtefactRouteGQL extends Apollo.Mutation<UpdateArtefactRouteMutation, UpdateArtefactRouteMutationVariables> {
    document = UpdateArtefactRouteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableArtefactRouteDocument = gql`
    mutation disableArtefactRoute($id: ID!) {
  disableArtefactRoute(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableArtefactRouteGQL extends Apollo.Mutation<DisableArtefactRouteMutation, DisableArtefactRouteMutationVariables> {
    document = DisableArtefactRouteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableArtefactRouteDocument = gql`
    mutation enableArtefactRoute($id: ID!) {
  enableArtefactRoute(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableArtefactRouteGQL extends Apollo.Mutation<EnableArtefactRouteMutation, EnableArtefactRouteMutationVariables> {
    document = EnableArtefactRouteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteArtefactRouteDocument = gql`
    mutation deleteArtefactRoute($id: ID!) {
  removeArtefactRoute(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteArtefactRouteGQL extends Apollo.Mutation<DeleteArtefactRouteMutation, DeleteArtefactRouteMutationVariables> {
    document = DeleteArtefactRouteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderArtefactRoutesDocument = gql`
    mutation orderArtefactRoutes($ids: [ID!]!) {
  orderArtefactRoutes(ids: $ids) {
    sequenceNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderArtefactRoutesGQL extends Apollo.Mutation<OrderArtefactRoutesMutation, OrderArtefactRoutesMutationVariables> {
    document = OrderArtefactRoutesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetArtefactDocument = gql`
    query getArtefact($id: ID!) {
  getArtefactById(id: $id) {
    ...artefactDetails
  }
}
    ${ArtefactDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetArtefactGQL extends Apollo.Query<GetArtefactQuery, GetArtefactQueryVariables> {
    document = GetArtefactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetArtefactOverviewDocument = gql`
    query getArtefactOverview($id: ID!) {
  getArtefactById(id: $id) {
    ...artefactOverview
  }
}
    ${ArtefactOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetArtefactOverviewGQL extends Apollo.Query<GetArtefactOverviewQuery, GetArtefactOverviewQueryVariables> {
    document = GetArtefactOverviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetArtefactsForScienceOrganisationDocument = gql`
    query getArtefactsForScienceOrganisation($id: ID!) {
  getScienceOrganisationById(id: $id) {
    artefacts {
      ...artefactOverview
    }
  }
}
    ${ArtefactOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetArtefactsForScienceOrganisationGQL extends Apollo.Query<GetArtefactsForScienceOrganisationQuery, GetArtefactsForScienceOrganisationQueryVariables> {
    document = GetArtefactsForScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetArtefactsForRoutesDocument = gql`
    query getArtefactsForRoutes($scienceOrganisationId: ID!) {
  getScienceOrganisationById(id: $scienceOrganisationId) {
    artefacts {
      _id
      titleAndDescriptions {
        language
        title
        description
      }
      disabled
      trashedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetArtefactsForRoutesGQL extends Apollo.Query<GetArtefactsForRoutesQuery, GetArtefactsForRoutesQueryVariables> {
    document = GetArtefactsForRoutesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateArtefactDocument = gql`
    mutation updateArtefact($id: ID!, $titleAndDescriptions: [SingleLanguageTitleDescriptionDTO!]!, $domains: [Domain!], $contentElementIds: [ID!]) {
  updateArtefact(
    id: $id
    updateArtefactInput: {titleAndDescriptions: $titleAndDescriptions, domains: $domains, contentElementIds: $contentElementIds}
  ) {
    ...artefactDetails
  }
}
    ${ArtefactDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateArtefactGQL extends Apollo.Mutation<UpdateArtefactMutation, UpdateArtefactMutationVariables> {
    document = UpdateArtefactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableArtefactDocument = gql`
    mutation disableArtefact($id: ID!) {
  disableArtefact(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableArtefactGQL extends Apollo.Mutation<DisableArtefactMutation, DisableArtefactMutationVariables> {
    document = DisableArtefactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableArtefactDocument = gql`
    mutation enableArtefact($id: ID!) {
  enableArtefact(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableArtefactGQL extends Apollo.Mutation<EnableArtefactMutation, EnableArtefactMutationVariables> {
    document = EnableArtefactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddArtefactToScienceOrganisationDocument = gql`
    mutation addArtefactToScienceOrganisation($id: ID!, $titleAndDescriptions: [SingleLanguageTitleDescriptionDTO!]!, $domains: [Domain!]!, $ageRanges: [AgeRange!]!) {
  addArtefactToScienceOrganisation(
    id: $id
    createArtefactInput: {titleAndDescriptions: $titleAndDescriptions, domains: $domains, ageRanges: $ageRanges, contentElementIds: [], childArtefactIds: [], parentArtefactId: null}
  ) {
    artefact {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddArtefactToScienceOrganisationGQL extends Apollo.Mutation<AddArtefactToScienceOrganisationMutation, AddArtefactToScienceOrganisationMutationVariables> {
    document = AddArtefactToScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveArtefactFromScienceOrganisationDocument = gql`
    mutation removeArtefactFromScienceOrganisation($id: ID!, $artefactId: ID!) {
  removeArtefactsFromScienceOrganisation(id: $id, oldArtefactIds: [$artefactId]) {
    artefacts {
      ...artefactDetails
    }
  }
}
    ${ArtefactDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveArtefactFromScienceOrganisationGQL extends Apollo.Mutation<RemoveArtefactFromScienceOrganisationMutation, RemoveArtefactFromScienceOrganisationMutationVariables> {
    document = RemoveArtefactFromScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderArtefactsDocument = gql`
    mutation orderArtefacts($ids: [ID!]!) {
  orderArtefacts(ids: $ids) {
    sequenceNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderArtefactsGQL extends Apollo.Mutation<OrderArtefactsMutation, OrderArtefactsMutationVariables> {
    document = OrderArtefactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateArtefactDocument = gql`
    mutation duplicateArtefact($id: ID!, $artefactId: ID!) {
  duplicateArtefactInScienceOrganisation(id: $id, artefactId: $artefactId) {
    scienceOrganisation {
      _id
    }
    artefact {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateArtefactGQL extends Apollo.Mutation<DuplicateArtefactMutation, DuplicateArtefactMutationVariables> {
    document = DuplicateArtefactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveArtefactToTrashDocument = gql`
    mutation moveArtefactToTrash($id: ID!) {
  moveArtefactToTrash(id: $id) {
    _id
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveArtefactToTrashGQL extends Apollo.Mutation<MoveArtefactToTrashMutation, MoveArtefactToTrashMutationVariables> {
    document = MoveArtefactToTrashDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RetrieveArtefactFromTrashDocument = gql`
    mutation retrieveArtefactFromTrash($id: ID!) {
  retrieveArtefactFromTrash(id: $id) {
    _id
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RetrieveArtefactFromTrashGQL extends Apollo.Mutation<RetrieveArtefactFromTrashMutation, RetrieveArtefactFromTrashMutationVariables> {
    document = RetrieveArtefactFromTrashDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContentElementsDocument = gql`
    query getContentElements {
  getAllContentElements {
    ...contentElementOverview
  }
}
    ${ContentElementOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContentElementsGQL extends Apollo.Query<GetContentElementsQuery, GetContentElementsQueryVariables> {
    document = GetContentElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllTrashedContentElementsDocument = gql`
    query getAllTrashedContentElements {
  getAllTrashedContentElements {
    ...contentElementOverview
  }
}
    ${ContentElementOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllTrashedContentElementsGQL extends Apollo.Query<GetAllTrashedContentElementsQuery, GetAllTrashedContentElementsQueryVariables> {
    document = GetAllTrashedContentElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContentElementOverviewDocument = gql`
    query getContentElementOverview($id: ID!) {
  getContentElementById(id: $id) {
    ...contentElementOverview
  }
}
    ${ContentElementOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContentElementOverviewGQL extends Apollo.Query<GetContentElementOverviewQuery, GetContentElementOverviewQueryVariables> {
    document = GetContentElementOverviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContentElementDocument = gql`
    query getContentElement($id: ID!) {
  getContentElementById(id: $id) {
    ...contentElementDetails
  }
}
    ${ContentElementDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContentElementGQL extends Apollo.Query<GetContentElementQuery, GetContentElementQueryVariables> {
    document = GetContentElementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContentElementsForArtefactDocument = gql`
    query getContentElementsForArtefact($id: ID!) {
  getArtefactById(id: $id) {
    contentElementIdsWithWarnings
    contentElements {
      ...contentElementOverview
    }
  }
}
    ${ContentElementOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContentElementsForArtefactGQL extends Apollo.Query<GetContentElementsForArtefactQuery, GetContentElementsForArtefactQueryVariables> {
    document = GetContentElementsForArtefactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableContentElementDocument = gql`
    mutation disableContentElement($id: ID!) {
  disableContentElement(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableContentElementGQL extends Apollo.Mutation<DisableContentElementMutation, DisableContentElementMutationVariables> {
    document = DisableContentElementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableContentElementDocument = gql`
    mutation enableContentElement($id: ID!) {
  enableContentElement(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableContentElementGQL extends Apollo.Mutation<EnableContentElementMutation, EnableContentElementMutationVariables> {
    document = EnableContentElementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteContentElementDocument = gql`
    mutation deleteContentElement($id: ID!) {
  removeContentPlugin(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteContentElementGQL extends Apollo.Mutation<DeleteContentElementMutation, DeleteContentElementMutationVariables> {
    document = DeleteContentElementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContentElementDocument = gql`
    mutation updateContentElement($id: ID!, $language: String, $title: String, $description: String, $ageRanges: [AgeRange!], $contentId: String, $configuration: JSON, $selfReportType: SelfReportType, $duringVisit: Boolean, $atHome: Boolean, $feedbackTitle: String, $feedbackBody: String) {
  updateContentElement(
    id: $id
    updateContentElementInput: {language: $language, title: $title, description: $description, ageRanges: $ageRanges, contentId: $contentId, configuration: $configuration, selfReportType: $selfReportType, duringVisit: $duringVisit, atHome: $atHome, feedbackTitle: $feedbackTitle, feedbackBody: $feedbackBody}
  ) {
    ...contentElementDetails
  }
}
    ${ContentElementDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContentElementGQL extends Apollo.Mutation<UpdateContentElementMutation, UpdateContentElementMutationVariables> {
    document = UpdateContentElementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddContentElementToArtefactDocument = gql`
    mutation addContentElementToArtefact($id: ID!, $description: String!, $title: String!, $language: String!, $ageRanges: [AgeRange!]!, $contentPluginId: ID!, $contentId: String!, $configuration: JSON, $duringVisit: Boolean, $atHome: Boolean) {
  addContentElementToArtefact(
    id: $id
    createContentElementInput: {title: $title, description: $description, language: $language, ageRanges: $ageRanges, contentPluginId: $contentPluginId, contentId: $contentId, configuration: $configuration, duringVisit: $duringVisit, atHome: $atHome}
  ) {
    contentElement {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddContentElementToArtefactGQL extends Apollo.Mutation<AddContentElementToArtefactMutation, AddContentElementToArtefactMutationVariables> {
    document = AddContentElementToArtefactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveContentElementsFromArtefactDocument = gql`
    mutation removeContentElementsFromArtefact($id: ID!, $contentElementId: ID!) {
  removeContentElementsFromArtefact(
    id: $id
    oldContentElementIds: [$contentElementId]
  ) {
    ...artefactDetails
  }
}
    ${ArtefactDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveContentElementsFromArtefactGQL extends Apollo.Mutation<RemoveContentElementsFromArtefactMutation, RemoveContentElementsFromArtefactMutationVariables> {
    document = RemoveContentElementsFromArtefactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderContentElementsDocument = gql`
    mutation orderContentElements($ids: [ID!]!) {
  orderContentElements(ids: $ids) {
    sequenceNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderContentElementsGQL extends Apollo.Mutation<OrderContentElementsMutation, OrderContentElementsMutationVariables> {
    document = OrderContentElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateContentElementDocument = gql`
    mutation duplicateContentElement($id: ID!, $contentElementId: ID!) {
  duplicateContentElementInArtefact(id: $id, contentElementId: $contentElementId) {
    artefact {
      _id
    }
    contentElement {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateContentElementGQL extends Apollo.Mutation<DuplicateContentElementMutation, DuplicateContentElementMutationVariables> {
    document = DuplicateContentElementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveContentElementToTrashDocument = gql`
    mutation moveContentElementToTrash($id: ID!) {
  moveContentElementToTrash(id: $id) {
    _id
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveContentElementToTrashGQL extends Apollo.Mutation<MoveContentElementToTrashMutation, MoveContentElementToTrashMutationVariables> {
    document = MoveContentElementToTrashDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RetrieveContentElementFromTrashDocument = gql`
    mutation retrieveContentElementFromTrash($id: ID!) {
  retrieveContentElementFromTrash(id: $id) {
    _id
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RetrieveContentElementFromTrashGQL extends Apollo.Mutation<RetrieveContentElementFromTrashMutation, RetrieveContentElementFromTrashMutationVariables> {
    document = RetrieveContentElementFromTrashDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContentPluginDocument = gql`
    query getContentPlugin($id: ID!) {
  getContentPluginById(id: $id) {
    ...editContentPluginDetails
  }
}
    ${EditContentPluginDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContentPluginGQL extends Apollo.Query<GetContentPluginQuery, GetContentPluginQueryVariables> {
    document = GetContentPluginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContentPluginsDocument = gql`
    query getContentPlugins {
  getAllContentPlugins {
    _id
    editorUrl
    useInChaser
    useInResults
    titleAndDescriptions {
      language
      title
      description
    }
    createdAt
    lastModificationAt
    disabled
    mayBeDeleted
    sequenceNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContentPluginsGQL extends Apollo.Query<GetContentPluginsQuery, GetContentPluginsQueryVariables> {
    document = GetContentPluginsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateContentPluginDocument = gql`
    mutation createContentPlugin($titleAndDescriptions: [SingleLanguageTitleDescriptionDTO!]!, $editorUrl: String!, $viewerUrl: String!, $resourceType: String!, $applicationName: String!, $useInChaser: Boolean!, $useInResults: Boolean!) {
  createContentPlugin(
    createContentPluginInput: {titleAndDescriptions: $titleAndDescriptions, editorUrl: $editorUrl, viewerUrl: $viewerUrl, resourceType: $resourceType, applicationName: $applicationName, useInChaser: $useInChaser, useInResults: $useInResults}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateContentPluginGQL extends Apollo.Mutation<CreateContentPluginMutation, CreateContentPluginMutationVariables> {
    document = CreateContentPluginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContentPluginDocument = gql`
    mutation updateContentPlugin($id: ID!, $titleAndDescriptions: [SingleLanguageTitleDescriptionDTO!], $editorUrl: String, $viewerUrl: String, $resourceType: String, $applicationName: String, $useInChaser: Boolean, $useInResults: Boolean) {
  updateContentPlugin(
    id: $id
    updateContentPluginInput: {titleAndDescriptions: $titleAndDescriptions, editorUrl: $editorUrl, viewerUrl: $viewerUrl, resourceType: $resourceType, applicationName: $applicationName, useInChaser: $useInChaser, useInResults: $useInResults}
  ) {
    ...editContentPluginDetails
  }
}
    ${EditContentPluginDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContentPluginGQL extends Apollo.Mutation<UpdateContentPluginMutation, UpdateContentPluginMutationVariables> {
    document = UpdateContentPluginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableContentPluginDocument = gql`
    mutation disableContentPlugin($id: ID!) {
  disableContentPlugin(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableContentPluginGQL extends Apollo.Mutation<DisableContentPluginMutation, DisableContentPluginMutationVariables> {
    document = DisableContentPluginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableContentPluginDocument = gql`
    mutation enableContentPlugin($id: ID!) {
  enableContentPlugin(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableContentPluginGQL extends Apollo.Mutation<EnableContentPluginMutation, EnableContentPluginMutationVariables> {
    document = EnableContentPluginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteContentPluginDocument = gql`
    mutation deleteContentPlugin($id: ID!) {
  removeContentPlugin(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteContentPluginGQL extends Apollo.Mutation<DeleteContentPluginMutation, DeleteContentPluginMutationVariables> {
    document = DeleteContentPluginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderContentPluginsDocument = gql`
    mutation orderContentPlugins($ids: [ID!]!) {
  orderContentPlugins(ids: $ids) {
    sequenceNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderContentPluginsGQL extends Apollo.Mutation<OrderContentPluginsMutation, OrderContentPluginsMutationVariables> {
    document = OrderContentPluginsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetIlsStructureJsonDocument = gql`
    query getIlsStructureJson($scienceOrganisationId: ID!) {
  getIlsStructureJson(scienceOrganisationId: $scienceOrganisationId) {
    ilsStructure
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIlsStructureJsonGQL extends Apollo.Query<GetIlsStructureJsonQuery, GetIlsStructureJsonQueryVariables> {
    document = GetIlsStructureJsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QueryResourcesJsonDocument = gql`
    query queryResourcesJson($scienceOrganisationId: ID!, $actorId: String, $appId: String, $resourceType: String, $orderByModificationDate: Boolean, $returnMetadataOnly: Boolean, $maxResults: Int, $pageNumber: Int) {
  queryResourcesJson(
    scienceOrganisationId: $scienceOrganisationId
    resourceQueryJSON: {actorId: $actorId, appId: $appId, resourceType: $resourceType, orderByModificationDate: $orderByModificationDate, returnMetadataOnly: $returnMetadataOnly, maxResults: $maxResults, pageNumber: $pageNumber}
  ) {
    resourceQueryResults
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QueryResourcesJsonGQL extends Apollo.Query<QueryResourcesJsonQuery, QueryResourcesJsonQueryVariables> {
    document = QueryResourcesJsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReadResourceJsonDocument = gql`
    query readResourceJson($scienceOrganisationId: ID!, $resourceId: ID!) {
  readResourceJson(
    scienceOrganisationId: $scienceOrganisationId
    resourceId: $resourceId
  ) {
    resourceReadResults
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReadResourceJsonGQL extends Apollo.Query<ReadResourceJsonQuery, ReadResourceJsonQueryVariables> {
    document = ReadResourceJsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateResourceJsonDocument = gql`
    query updateResourceJson($resource: ResourceJSONInput!) {
  updateResourceJson(resource: $resource) {
    resourceUpdateResults
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateResourceJsonGQL extends Apollo.Query<UpdateResourceJsonQuery, UpdateResourceJsonQueryVariables> {
    document = UpdateResourceJsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RetrieveLogActionsJsonDocument = gql`
    query retrieveLogActionsJson($scienceOrganisationId: ID!, $logActionQueryJSONInput: LogActionQueryJSONInput!, $logActionProjectionJSONInput: LogActionProjectionJSONInput!) {
  retrieveLogActionsJson(
    scienceOrganisationId: $scienceOrganisationId
    logActionQueryJSONInput: $logActionQueryJSONInput
    logActionProjectionJSONInput: $logActionProjectionJSONInput
  ) {
    logAccessorQueryResults
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RetrieveLogActionsJsonGQL extends Apollo.Query<RetrieveLogActionsJsonQuery, RetrieveLogActionsJsonQueryVariables> {
    document = RetrieveLogActionsJsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RetrieveActorsDocument = gql`
    query retrieveActors {
  retrieveActors {
    id
    displayName
    objectType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RetrieveActorsGQL extends Apollo.Query<RetrieveActorsQuery, RetrieveActorsQueryVariables> {
    document = RetrieveActorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersWithNotificationsEnabledDocument = gql`
    query getUsersWithNotificationsEnabled {
  getUsersWithNotificationsEnabled {
    _id
    loginName
    deviceIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersWithNotificationsEnabledGQL extends Apollo.Query<GetUsersWithNotificationsEnabledQuery, GetUsersWithNotificationsEnabledQueryVariables> {
    document = GetUsersWithNotificationsEnabledDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendGenericActivityReminderToEveryoneDocument = gql`
    mutation sendGenericActivityReminderToEveryone {
  sendGenericActivityReminderToEveryone {
    _id
    accountsWhoReceivedNotifications {
      _id
      loginName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendGenericActivityReminderToEveryoneGQL extends Apollo.Mutation<SendGenericActivityReminderToEveryoneMutation, SendGenericActivityReminderToEveryoneMutationVariables> {
    document = SendGenericActivityReminderToEveryoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDaysDocument = gql`
    mutation sendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDays {
  sendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDays {
    _id
    accountsWhoReceivedNotifications {
      _id
      loginName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDaysGQL extends Apollo.Mutation<SendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDaysMutation, SendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDaysMutationVariables> {
    document = SendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDaysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDaysDocument = gql`
    mutation sendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDays {
  sendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDays {
    _id
    accountsWhoReceivedNotifications {
      _id
      loginName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDaysGQL extends Apollo.Mutation<SendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDaysMutation, SendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDaysMutationVariables> {
    document = SendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDaysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendStreakReminderToEveryoneDocument = gql`
    mutation sendStreakReminderToEveryone {
  sendStreakReminderToEveryone {
    _id
    accountsWhoReceivedNotifications {
      _id
      loginName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendStreakReminderToEveryoneGQL extends Apollo.Mutation<SendStreakReminderToEveryoneMutation, SendStreakReminderToEveryoneMutationVariables> {
    document = SendStreakReminderToEveryoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendStreakAboutToExpireToEveryoneDocument = gql`
    mutation sendStreakAboutToExpireToEveryone {
  sendStreakAboutToExpireToEveryone {
    _id
    accountsWhoReceivedNotifications {
      _id
      loginName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendStreakAboutToExpireToEveryoneGQL extends Apollo.Mutation<SendStreakAboutToExpireToEveryoneMutation, SendStreakAboutToExpireToEveryoneMutationVariables> {
    document = SendStreakAboutToExpireToEveryoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendNotificationDocument = gql`
    mutation sendNotification($title: String!, $body: String!, $scienceOrganisationId: ID, $artefactId: ID, $contentElementId: ID) {
  sendNotification(
    notification: {title: $title, body: $body, scienceOrganisationId: $scienceOrganisationId, artefactId: $artefactId, contentElementId: $contentElementId}
  ) {
    _id
    accountsWhoReceivedNotifications {
      _id
      loginName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendNotificationGQL extends Apollo.Mutation<SendNotificationMutation, SendNotificationMutationVariables> {
    document = SendNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationsDocument = gql`
    query getNotifications {
  getNotifications {
    ...notificationOverview
  }
}
    ${NotificationOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationsGQL extends Apollo.Query<GetNotificationsQuery, GetNotificationsQueryVariables> {
    document = GetNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationDocument = gql`
    query getNotification($id: ID!) {
  getNotificationById(id: $id) {
    ...notificationDetails
  }
}
    ${NotificationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationGQL extends Apollo.Query<GetNotificationQuery, GetNotificationQueryVariables> {
    document = GetNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationsForScienceOrganisationDocument = gql`
    query getNotificationsForScienceOrganisation($id: ID!) {
  getScienceOrganisationById(id: $id) {
    notifications {
      ...notificationOverview
    }
  }
}
    ${NotificationOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationsForScienceOrganisationGQL extends Apollo.Query<GetNotificationsForScienceOrganisationQuery, GetNotificationsForScienceOrganisationQueryVariables> {
    document = GetNotificationsForScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindQrCodeDescriptionDocument = gql`
    query findQrCodeDescription($code: String!) {
  findQrCodeDescription(code: $code) {
    targetType
    artefactId
    contentElementId
    scienceOrganisationId
    scienceOrganisation {
      _id
      titleAndDescriptions {
        language
        title
      }
      logoUrl
    }
    artefact {
      _id
      titleAndDescriptions {
        language
        title
      }
    }
    contentElement {
      _id
      title
    }
    artefactRouteId
    artefactRoute {
      _id
      titleAndDescriptions {
        language
        title
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FindQrCodeDescriptionGQL extends Apollo.Query<FindQrCodeDescriptionQuery, FindQrCodeDescriptionQueryVariables> {
    document = FindQrCodeDescriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateQrCodeDocument = gql`
    mutation createQrCode($targetId: ID!, $targetType: QrCodeTargetType!) {
  createQrCode(createQrCodeInput: {targetId: $targetId, targetType: $targetType}) {
    targetType
    targetId
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateQrCodeGQL extends Apollo.Mutation<CreateQrCodeMutation, CreateQrCodeMutationVariables> {
    document = CreateQrCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScienceOrganisationsDocument = gql`
    query getScienceOrganisations {
  getAllScienceOrganisations {
    ...scienceOrganisationOverview
  }
}
    ${ScienceOrganisationOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScienceOrganisationsGQL extends Apollo.Query<GetScienceOrganisationsQuery, GetScienceOrganisationsQueryVariables> {
    document = GetScienceOrganisationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllTrashedScienceOrganisationsDocument = gql`
    query getAllTrashedScienceOrganisations {
  getAllTrashedScienceOrganisations {
    ...scienceOrganisationOverview
  }
}
    ${ScienceOrganisationOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllTrashedScienceOrganisationsGQL extends Apollo.Query<GetAllTrashedScienceOrganisationsQuery, GetAllTrashedScienceOrganisationsQueryVariables> {
    document = GetAllTrashedScienceOrganisationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScienceOrganisationsWithMembersArtefactsContentElementsDocument = gql`
    query getScienceOrganisationsWithMembersArtefactsContentElements {
  getAllScienceOrganisations {
    ...scienceOrganisationDetailsWithOnlyIds
  }
}
    ${ScienceOrganisationDetailsWithOnlyIdsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScienceOrganisationsWithMembersArtefactsContentElementsGQL extends Apollo.Query<GetScienceOrganisationsWithMembersArtefactsContentElementsQuery, GetScienceOrganisationsWithMembersArtefactsContentElementsQueryVariables> {
    document = GetScienceOrganisationsWithMembersArtefactsContentElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTrashedScienceOrganisationsWithMembersArtefactsContentElementsDocument = gql`
    query getTrashedScienceOrganisationsWithMembersArtefactsContentElements {
  getAllTrashedScienceOrganisations {
    ...scienceOrganisationDetailsWithOnlyIds
  }
}
    ${ScienceOrganisationDetailsWithOnlyIdsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTrashedScienceOrganisationsWithMembersArtefactsContentElementsGQL extends Apollo.Query<GetTrashedScienceOrganisationsWithMembersArtefactsContentElementsQuery, GetTrashedScienceOrganisationsWithMembersArtefactsContentElementsQueryVariables> {
    document = GetTrashedScienceOrganisationsWithMembersArtefactsContentElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScienceOrganisationOverviewDocument = gql`
    query getScienceOrganisationOverview($id: ID!) {
  getScienceOrganisationById(id: $id) {
    ...scienceOrganisationOverview
  }
}
    ${ScienceOrganisationOverviewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScienceOrganisationOverviewGQL extends Apollo.Query<GetScienceOrganisationOverviewQuery, GetScienceOrganisationOverviewQueryVariables> {
    document = GetScienceOrganisationOverviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScienceOrganisationDocument = gql`
    query getScienceOrganisation($id: ID!) {
  getScienceOrganisationById(id: $id) {
    ...scienceOrganisationDetails
  }
}
    ${ScienceOrganisationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScienceOrganisationGQL extends Apollo.Query<GetScienceOrganisationQuery, GetScienceOrganisationQueryVariables> {
    document = GetScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAccountsForScienceOrganisationDocument = gql`
    query getAccountsForScienceOrganisation($id: ID!) {
  getAccountsForScienceOrganisation(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccountsForScienceOrganisationGQL extends Apollo.Query<GetAccountsForScienceOrganisationQuery, GetAccountsForScienceOrganisationQueryVariables> {
    document = GetAccountsForScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMemberAccountsDocument = gql`
    query getMemberAccounts {
  getAccounts(accountQuery: {accountTypes: [ProjectMember], disabled: false}) {
    _id
    loginName
    accountType
    disabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMemberAccountsGQL extends Apollo.Query<GetMemberAccountsQuery, GetMemberAccountsQueryVariables> {
    document = GetMemberAccountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteScienceOrganisationDocument = gql`
    mutation deleteScienceOrganisation($id: ID!) {
  removeScienceOrganisation(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteScienceOrganisationGQL extends Apollo.Mutation<DeleteScienceOrganisationMutation, DeleteScienceOrganisationMutationVariables> {
    document = DeleteScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateScienceOrganisationDocument = gql`
    mutation createScienceOrganisation($titleAndDescriptions: [SingleLanguageTitleDescriptionDTO!]!, $memberIds: [ID!]!, $location: LocationDTO!, $websiteUrl: String, $logoUrl: String) {
  createScienceOrganisation(
    createScienceOrganisationInput: {titleAndDescriptions: $titleAndDescriptions, memberIds: $memberIds, location: $location, websiteUrl: $websiteUrl, logoUrl: $logoUrl}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateScienceOrganisationGQL extends Apollo.Mutation<CreateScienceOrganisationMutation, CreateScienceOrganisationMutationVariables> {
    document = CreateScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateScienceOrganisationDocument = gql`
    mutation updateScienceOrganisation($id: ID!, $titleAndDescriptions: [SingleLanguageTitleDescriptionDTO!]!, $memberIds: [ID!], $websiteUrl: String, $logoUrl: String, $location: LocationDTO!, $artefactRouteIds: [ID!]) {
  updateScienceOrganisation(
    id: $id
    updateScienceOrganisationInput: {titleAndDescriptions: $titleAndDescriptions, memberIds: $memberIds, location: $location, websiteUrl: $websiteUrl, logoUrl: $logoUrl, artefactRouteIds: $artefactRouteIds}
  ) {
    ...scienceOrganisationDetails
  }
}
    ${ScienceOrganisationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateScienceOrganisationGQL extends Apollo.Mutation<UpdateScienceOrganisationMutation, UpdateScienceOrganisationMutationVariables> {
    document = UpdateScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableScienceOrganisationDocument = gql`
    mutation disableScienceOrganisation($id: ID!) {
  disableScienceOrganisation(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableScienceOrganisationGQL extends Apollo.Mutation<DisableScienceOrganisationMutation, DisableScienceOrganisationMutationVariables> {
    document = DisableScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableScienceOrganisationDocument = gql`
    mutation enableScienceOrganisation($id: ID!) {
  enableScienceOrganisation(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableScienceOrganisationGQL extends Apollo.Mutation<EnableScienceOrganisationMutation, EnableScienceOrganisationMutationVariables> {
    document = EnableScienceOrganisationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderScienceOrganisationsDocument = gql`
    mutation orderScienceOrganisations($ids: [ID!]!) {
  orderScienceOrganisations(ids: $ids) {
    sequenceNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderScienceOrganisationsGQL extends Apollo.Mutation<OrderScienceOrganisationsMutation, OrderScienceOrganisationsMutationVariables> {
    document = OrderScienceOrganisationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveScienceOrganisationToTrashDocument = gql`
    mutation moveScienceOrganisationToTrash($id: ID!) {
  moveScienceOrganisationToTrash(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveScienceOrganisationToTrashGQL extends Apollo.Mutation<MoveScienceOrganisationToTrashMutation, MoveScienceOrganisationToTrashMutationVariables> {
    document = MoveScienceOrganisationToTrashDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RetrieveScienceOrganisationFromTrashDocument = gql`
    mutation retrieveScienceOrganisationFromTrash($id: ID!) {
  retrieveScienceOrganisationFromTrash(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RetrieveScienceOrganisationFromTrashGQL extends Apollo.Mutation<RetrieveScienceOrganisationFromTrashMutation, RetrieveScienceOrganisationFromTrashMutationVariables> {
    document = RetrieveScienceOrganisationFromTrashDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllSelfReportsExcelWithAccountInfoDocument = gql`
    query getAllSelfReportsExcelWithAccountInfo {
  getAllSelfReportsExcelWithAccountInfo
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllSelfReportsExcelWithAccountInfoGQL extends Apollo.Query<GetAllSelfReportsExcelWithAccountInfoQuery, GetAllSelfReportsExcelWithAccountInfoQueryVariables> {
    document = GetAllSelfReportsExcelWithAccountInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetServerStatusDocument = gql`
    query getServerStatus {
  getServerStatus {
    totalDiskSpace
    freeDiskSpace
    nrOfCpus
    totalMemory
    freeMemory
    osType
    osVersion
    osRelease
    uptime
    averageLoad
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServerStatusGQL extends Apollo.Query<GetServerStatusQuery, GetServerStatusQueryVariables> {
    document = GetServerStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStorageStatusOverviewDocument = gql`
    query getStorageStatusOverview {
  getStorageStatusOverview {
    collectionOverviews {
      ...collectionOverviewDetails
    }
    mongoDbVersion {
      version
      openSslRunningVersion
      openSslCompiledVersion
      ok
    }
  }
}
    ${CollectionOverviewDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStorageStatusOverviewGQL extends Apollo.Query<GetStorageStatusOverviewQuery, GetStorageStatusOverviewQueryVariables> {
    document = GetStorageStatusOverviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMigrationsDocument = gql`
    query getMigrations {
  getMigrations {
    _id
    fileName
    appliedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMigrationsGQL extends Apollo.Query<GetMigrationsQuery, GetMigrationsQueryVariables> {
    document = GetMigrationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCollectionIndicesDocument = gql`
    query getCollectionIndices {
  getCollectionIndices {
    name
    indices {
      fields {
        key
        value
      }
      options {
        key
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCollectionIndicesGQL extends Apollo.Query<GetCollectionIndicesQuery, GetCollectionIndicesQueryVariables> {
    document = GetCollectionIndicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddLogActionDocument = gql`
    mutation addLogAction($sessionSequenceNumber: Int!, $actorId: ID!, $clientDate: Timestamp!, $app: ActionApp!, $verb: ActionVerb!, $targetType: TargetTypes!, $targetId: ID!, $description: JSON!) {
  addLogAction(
    addLogActionInput: {sessionSequenceNumber: $sessionSequenceNumber, actorId: $actorId, clientDate: $clientDate, app: $app, verb: $verb, targetType: $targetType, targetId: $targetId, description: $description}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddLogActionGQL extends Apollo.Mutation<AddLogActionMutation, AddLogActionMutationVariables> {
    document = AddLogActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogActionSummariesDocument = gql`
    query getLogActionSummaries($actionApps: [ActionApp!], $actionVerbs: [ActionVerb!], $targetTypes: [TargetTypes!]) {
  getLogActionSummaries(
    logActionSummaryQuery: {actionApps: $actionApps, actionVerbs: $actionVerbs, targetTypes: $targetTypes}
  ) {
    logActionSummaries {
      _id
      serverDate
      clientDate
      loginName
      sessionSequenceNumber
      verb
      targetType
      app
    }
    totalNr
    nrsPerActionApp {
      key
      count
    }
    nrsPerActionVerb {
      key
      count
    }
    nrsPerTargetType {
      key
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogActionSummariesGQL extends Apollo.Query<GetLogActionSummariesQuery, GetLogActionSummariesQueryVariables> {
    document = GetLogActionSummariesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogActionKeyCountsDocument = gql`
    query getLogActionKeyCounts($actionApps: [ActionApp!], $actionVerbs: [ActionVerb!], $targetTypes: [TargetTypes!], $scienceOrganisationIds: [ID!]!, $startDate: Timestamp, $endDate: Timestamp) {
  getLogActionKeyCounts(
    logActionQuery: {actionApps: $actionApps, actionVerbs: $actionVerbs, targetTypes: $targetTypes, scienceOrganisationIds: $scienceOrganisationIds, startDate: $startDate, endDate: $endDate}
  ) {
    totalNr
    nrsPerActionApp {
      key
      count
    }
    nrsPerActionVerb {
      key
      count
    }
    nrsPerTargetType {
      key
      count
    }
    nrsPerScienceOrganisationId {
      key
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogActionKeyCountsGQL extends Apollo.Query<GetLogActionKeyCountsQuery, GetLogActionKeyCountsQueryVariables> {
    document = GetLogActionKeyCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogActionsByQueryDocument = gql`
    query getLogActionsByQuery($actionApps: [ActionApp!], $actionVerbs: [ActionVerb!], $targetTypes: [TargetTypes!], $pageSize: Int!, $page: Int!, $scienceOrganisationIds: [ID!]!, $startDate: Timestamp, $endDate: Timestamp, $lastLogActionId: String) {
  getLogActionsByQuery(
    logActionSummaryQuery: {actionApps: $actionApps, actionVerbs: $actionVerbs, targetTypes: $targetTypes, scienceOrganisationIds: $scienceOrganisationIds, startDate: $startDate, endDate: $endDate}
    pageSize: $pageSize
    page: $page
    lastLogActionId: $lastLogActionId
  ) {
    _id
    clientDate
    serverDate
    actorId
    actor {
      _id
      loginName
      accountType
    }
    sessionSequenceNumber
    verb
    app
    targetType
    targetId
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogActionsByQueryGQL extends Apollo.Query<GetLogActionsByQueryQuery, GetLogActionsByQueryQueryVariables> {
    document = GetLogActionsByQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogActionDocument = gql`
    query getLogAction($id: ID!) {
  getLogActionById(id: $id) {
    _id
    clientDate
    serverDate
    actorId
    actor {
      _id
      loginName
      accountType
    }
    sessionSequenceNumber
    verb
    targetType
    targetId
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogActionGQL extends Apollo.Query<GetLogActionQuery, GetLogActionQueryVariables> {
    document = GetLogActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNrOfLogActionsDocument = gql`
    query getNrOfLogActions {
  getNrOfLogActions {
    nrOfServerLogActions
    nrOfDigitalToolboxManagerLogActions
    nrOfChaserLogActions
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNrOfLogActionsGQL extends Apollo.Query<GetNrOfLogActionsQuery, GetNrOfLogActionsQueryVariables> {
    document = GetNrOfLogActionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }